export const CreditAppStateMock = {
  "Sitecore": {
      "CreditApplicationConfig": {
          "Groups": {
              "PrequalLegacyCA": "Prequal CA",
              "PersonalInfo": "Personal Info",
              "ResidenceInfo": "Residence Info",
              "EmploymentInfo": "Employment Info",
              "AdditionalInfo": "Additional Info",
              "CoBuyerPersonal": "Co-Buyer Personal Info",
              "CoBuyerResidence": "Co-Buyer Residence Info",
              "CoBuyerEmployment": "Co-Buyer Employment Info",
              "CoBuyerAdditional": "Co-Buyer Additional Info",
              "ReviewInfo": "Review Info"
          },
          "JackedCTA": "OK",
          "JackedImage": "/~/media/Images/Autonation/CreditApplication/jackedImage.svg",
          "JackedMessage": "Sorry, there was a problem with your request. Please try again later.",
          "JackedTitle": "Something is jacked up",
          "LeadRouteJackedCTA": "Return to Homepage",
          "LeadRouteJackedImage": "/~/media/Images/Autonation/CreditApplication/LeadRouteJackedImage.svg",
          "LeadRouteJackedMessage": "Unfortunately we are unable to sell vehicles in your market. However, our locations are constantly expanding and your city may be next. Please check again in the near future.",
          "LeadRouteJackedTitle": "Something’s Jacked Up!",
          "SelectsDefaultLabel": "Select",
          "UnlockCTA": "Unlock",
          "UnlockError": "Please provide the last 4 digits of your Social Security Number",
          "AdditionalInfo": {
              "AdditionalIncomeDisclaimer": "Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.",
              "AdditionalIncomeLabel": "Additional income (Optional)",
              "AdditionalIncomeRequired": "",
              "CoBuyerLabel": "Will there be a co-buyer?",
              "CoBuyerNo": "No",
              "CoBuyerYes": "Yes",
              "IncomeFrequencyLabel": "Income frequency",
              "IncomeFrequencyRequired": "Please select the required income frequency",
              "IncomeSourceLabel": "Income source",
              "IncomeSourceRequired": "Please select the required income source",
              "BackCta": "Back",
              "NextCta": "Next"
          },
          "EmploymentInfo": {
              "EmployerNameInvalid": "Employer name is invalid",
              "EmployerNameLabel": "Employer name",
              "EmployerNameRequired": "Please provide employer name",
              "EmployerPhoneNumberInvalid": "Employer phone number is invalid",
              "EmployerPhoneNumberLabel": "Employer phone number",
              "EmployerPhoneNumberRequired": "Please provide employer phone number",
              "EmploymentStatusLabel": "Employment status",
              "EmploymentStatusRequired": "Please select employment status",
              "EmploymentTypeLabel": "Employment type",
              "EmploymentTypeRequired": "Please select employment type",
              "GrossSalaryLabel": "Gross annual income",
              "GrossSalaryRequired": "Please provide gross salary",
              "IncomeFrequencyLabel": "Income Frequency",
              "IncomeFrequencyRequired": "Please select income frequency",
              "JobTitleInvalid": "Job title is invalid",
              "JobTitleLabel": "Job Title",
              "JobTitleRequired": "Job title is required",
              "ReviewTotolyearMonthTitle": "Total years and months at job",
              "TotalMnthsZeroValidation": "Years and Months both cannot be zero",
              "TotalMonthsAtJobLabel": "Total months at job",
              "TotalMonthsAtJobRequired": "Please select total motnhs at job",
              "TotalYearsAtJobLabel": "Total years at job",
              "TotalYearsAtJobRequired": "Please select total years at job",
              "TotalYrsZeroValidation": "Years and Months both cannot be zero",
              "BackCta": "Back",
              "NextCta": "Next"
          },
          "PersonalInformation": {
              "CoBuyerRelationshipToPrimaryApplicantLabel": "Relationship to primary applicant",
              "CoBuyerRelationshipToPrimaryApplicantRequired": "Please make a selection",
              "CoBuyerTitle": "Please tell us about your co-buyer",
              "DOBInvalid": "Date of birth is invalid",
              "DOBLabel": "Date of birth",
              "DOBRequired": "Date of birth is required",
              "EmailInvalid": "Emaill address is invalid",
              "EmailLabel": "Email address",
              "EmailRequired": "Please enter your Email address",
              "FirstNameInvalid": "First name is invalid",
              "FirstNameLabel": "First name",
              "FirstNameRequired": "Please enter your First Name",
              "LastNameInvalid": "Last name is invalid",
              "LastNameLabel": "Last name",
              "LastNameRequired": "Please enter your Last Name",
              "MIInvalid": "MI is invalid",
              "MILabel": "MI (Optional)",
              "PhoneInvalid": "Phone number is invalid",
              "PhoneLabel": "Phone number",
              "PhoneRequired": "Please enter your Phone Number",
              "Ssn1invalid": "Social security number is invalid",
              "Ssn1label": "Social Security Number",
              "Ssn1required": "Please enter your Social Security Number",
              "Ssn2invalid": "Social Security Number confirmation is invalid",
              "Ssn2label": "Confirm Social Security Number",
              "Ssn2required": "Please confirm your social security number",
              "SSNCobuyerInvalid": "Buyer SSN must be different than co-buyer SSN",
              "DOBRegExp": "",
              "SSNRegExp": "",
              "BackCta": "Back",
              "NextCta": "Next",
              "Title": "Please tell us about yourself",
              "LeagcyCaTitle": "Thank you, {FIRSTNAME} ! Please provide us with a little more information so we can complete your request.",
              "LeagcyQualifiedTitle": "Congratulations {FIRSTNAME}! You're pre-qualified for a loan up to ${dollar_amount}."
          },
          "PreQualificationInformation": {
              "BackCTA": "BACK",
              "BackStep": "Back",
              "BuyNowHomeDeliveryEnable": false,
              "BuyNowPreQualEnable": true,
              "BuyNowPrequalResultSubTitle": "Thank you for submitting your information!  Please see your results below.  We'll reach out to you if we need more information.",
              "BuyNowPrequalResultTitle": "Your pre-qualification results",
              "DOBRequiredError": "DOB is required",
              "HomeDeliveryText": "I am interested in",
              "HomeDeliveryTooltip": "Our Associates will guide you through every step of the experience using online tools. You can start online and finish in store or start in store and finish online. You pick. We believe that you deserve the freedom to choose the experience that works best for you. Shop, buy and sell all from the convenience of any location you choose.",
              "IsPrequalSelectedByDefault": false,
              "PersonalDetailsSubtitle": "Enter your name and contact information in case we have any questions about your vehicle purchase.",
              "PersonalDetailsTitle": "Let’s start with your details",
              "PhoneRequiredError": "Phone is required",
              "PrequalResults": "Your pre-qualification results",
              "PrequalSubheader": "",
              "PreQualText": "Pre-qualify me without impacting my credit",
              "PreQualTooltip": "Get pre-qualified instantly to get an idea of what you can spend on a new or used vehicle, all without impacting your credit score.  Whatever your financial situation, AutoNation will work you to find a solution.",
              "SSNRequiredError": "SSN is required",
              "StoreToDoorLogo": {
                  "Src": "/~/media/Autonation/BuyNow/storetohome.svg"
              },
              "ClosedLabel": "Closed",
              "FailureDisclaimer": "We need more information to complete your request. Please contact a store to continue.",
              "FailureDisclaimerVDPEntry": "We need more information to complete your request. The store will be in touch with you shortly with next steps.",
              "FailureHeader": "Thank you, {FIRSTNAME}.",
              "FailureIcon": {
                  "Alt": "failure icon",
                  "Src": "/~/media/Images/Autonation/CreditApplication/prequal-failure.svg"
              },
              "LocationIcon": {
                  "Alt": "store location ",
                  "Src": "/~/media/Images/Autonation/CreditApplication/store-location.svg"
              },
              "PhoneIcon": {
                  "Alt": "store phone",
                  "Src": "/~/media/Images/Autonation/CreditApplication/store-phone.svg"
              },
              "StoreHoursLabel": "Store Hours",
              "SuccessDisclaimer": "This pre-qualified loan amount is only valid at any AutoNation Store. This offer is not guaranteed if you do not meet our criteria including payment to income requirements and providing acceptable property as collateral.",
              "SuccessHeader": "Great news, {FIRSTNAME}! You’re prequalified for a monthly payment up to",
              "SuccessHeaderQualAmtSuffix": "/mo",
              "SuccessHeaderQualMinAmt": 100,
              "SuccessIcon": {
                  "Alt": "success icon",
                  "Src": "/~/media/Images/Autonation/CreditApplication/prequal-success.svg"
              },
              "TodayLabel": "Today",
              "Address": "Address",
              "AddressInvalidError": "Address is invalid",
              "AddressRequiredError": "Please enter address",
              "Address2": "Address2",
              "Address2InvalidError": "Address2 is invalid",
              "City": "City",
              "CityInvalidError": "City is invalid",
              "CityRequiredError": "Please enter city",
              "DateofBirth": "Date of birth",
              "DateOfBirthInvalidError": "MM/DD/YYYY",
              "Email": "Email",
              "EmailInvalidError": "Email is invalid",
              "EmailRequiredError": "Please enter email",
              "FirstName": "First name",
              "FirstNameInvalidError": "First name is invalid",
              "FirstNameRequiredError": "Please enter first name",
              "IAgreeCTA": "NEXT",
              "LastName": "Last name ",
              "LastNameInvalidError": "Last name is invalid",
              "LastNameRequiredError": "Please enter last name",
              "MiddleName": "MI (optional)",
              "MIInvalid": "Invalid MI",
              "Phone": "Phone",
              "PhoneInvalidError": "Phone is Invalid",
              "PhoneInvalidAreaCode": "Valid US area codes start with 2-9",
              "PreQualDisclaimer": "I understand that by clicking on  I AGREE, I am providing written instructions to AutoNation under the Fair Credit Reporting Act authorizing AutoNation to obtain information from my personal credit profile or other information from Experian. I authorize AutoNation to obtain such information solely to prequalify me for financing options.",
              "PreQualMessage": "Please complete our secure online application to instantly see your options.",
              "PreQualTitle": "Get pre-qualified for financing without impacting your credit score",
              "SSN": "SSN",
              "SSNInvalidError": "SSN is invalid",
              "MortgageRent": "Mortgage/Rent Amount",
              "MortgageRentTooltip": "The amount you are responsible to pay each month for your mortgage or rent payment.",
              "MortgageRentRequiredError": "Mortgage/Rent is required",
              "MortgageRentInvalidError": "Mortgage/Rent is invalid",
              "AnnualIncome": "Annual Income",
              "AnnualIncomeTooltip": "This is your total yearly income, before taxes",
              "AnnualIncomeRequiredError": "Annual Income is required",
              "AnnualIncomeInvalidError": "Annual Income is invalid",
              "State": "State",
              "StateRequiredError": "Select",
              "Zipcode": "Zip code",
              "ZipCodeInvalidError": "Zipcode is Invalid",
              "ZipCodeRequiredError": "Please enter zip code",
              "IsORLabel": "or",
              "PrequalWithoutVOIRedirectsTo": {
                  "Url": "/cars-for-sale"
              },
              "PrequalWithoutVOISearchRadius": "200",
              "ShowBirthDateStandAlonePrequal": true,
              "ShowSSNStandAlonePrequal": true,
              "SSNStandAloneErrormessage": "SSN is Invalid",
              "StandAlonePreQualConfirmationDescription": "<style>\r\n.failure-dislaimer ul{\r\ntext-align: left;\r\nmargin-left: 30px;\r\n}\r\n.failure-dislaimer ul li{\r\nlist-style: disc;\r\nmargin-bottom: 10px;\r\n}\r\n</style>\r\n<div class=\"failure-dislaimer\">\r\n<div>\r\n<ul>\r\n<li>Select a vehicle within your budget.</li>\r\n<li>Make a down payment of 20%.</li>\r\n<li>Trade-in another vehicle.</li>\r\n<li>Consider getting a co-buyer.</li>\r\n</ul>\r\n</div>\r\n</div>",
              "StandalonePreQualDisclaimer": "<div style=\"margin-bottom: 5px;font-size: 12px;line-height: 12px;color: var(--gray-600);padding: 0;font-family: 'Autonation Regular';\" class=\"col-12 disclaimer-text text-gray-ada\">By clicking Next, I agree to the <a href=\"/terms-of-use/terms?terms\" style=\"text-decoration: underline;font-family: 'Autonation Regular';font-size: 12px;font-weight: 500;color: var(--gray-700);margin-bottom: 0px;\">Terms of use</a> (including the Arbitration Agreement and Class Action Waiver in Section 17), and I am providing written instruction to AutoNation under the Fair Credit Reporting Act authorizing AutoNation to obtain information from my personal credit profile or other information from Experian. I authorize AutoNation to obtain such information solely to prequalify me for financing options.</div><div style=\"margin-bottom: 5px;font-size: 12px;line-height: 12px;color: var(--gray-600);padding: 0;\" class=\"col-12 disclaimer-text text-gray-ada\">By clicking Next, I consent to receive marketing emails, calls and texts from AutoNation and its <a href=\"/autonation-authorized-companies\" style=\"font-family: 'Autonation Regular';font-weight: 500;text-decoration-line: underline;color: var(--gray-600);\" target=\"_blank\"> authorized companies</a> at the number provided, including calls and text sent using automated technology. Consent is not required to purchase. </div>",
              "StandalonePreQualAuth": "<div style=\"margin-bottom: 5px;font-size: 12px;line-height: 12px;color: var(--gray-600);padding: 0;\" class=\"col-12 disclaimer-text text-gray-ada\">By clicking Next, I consent to receive marketing emails, calls and texts from AutoNation and its <a href=\"/autonation-authorized-companies\" style=\"font-family: 'Autonation Regular';font-weight: 500;text-decoration-line: underline;color: var(--gray-600);\" target=\"_blank\"> authorized companies</a> at the number provided, including calls and text sent using automated technology. Consent is not required to purchase. </div>",
              "BackCta": "BACK",
              "NextCta": "Next"
          },
          "PreviousEmploymentInfo": {
              "PreviousEmployerNameInvalid": "Previos employer name is invalid",
              "PreviousEmployerNameLabel": "Previous employer name",
              "PreviousEmployerNameRequired": "Please provide previous employer name",
              "PreviousEmployerPhoneNumberInvalid": "Previous employer phone number is invalid",
              "PreviousEmployerPhoneNumberLabel": "Employer phone number",
              "PreviousEmployerPhoneNumberRequired": "Please provide previous employer phone number",
              "PreviousEmploymentStatusLabel": "Previous employment status",
              "PreviousEmploymentStatusRequired": "Please select previous employment status",
              "PreviousEmploymentTypeInvalid": "Please select previous employment type",
              "PreviousEmploymentTypeLabel": "Previous employment type",
              "PreviousGrossSalaryInvalid": "Previous gross salary is invalid",
              "PreviousGrossSalaryLabel": "Gross annual income",
              "PreviousGrossSalaryRequired": "Please provide previous gross salary",
              "PreviousIncomeFrequencyLabel": "Previous income frequency",
              "PreviousIncomeFrequencyRequired": "Please select previous income frequency",
              "PreviousJobTitleInvalid": "Previous job title is invalid",
              "PreviousJobTitleLabel": "Previous job title",
              "PreviousJobTitleRequired": "Previous job title is required",
              "PreviousTotalMonthsAtJobLabel": "Previous total months at job",
              "PreviousTotalMonthsAtJobRequired": "Please select previous total motnhs at job",
              "PreviousTotalYearsAtJobLabel": "Previous total years at job",
              "PreviousTotalYearsAtJobRequired": "Please select previous total years at job",
              "ReviewTotolyearMonthTitle": "Total years and months at previous job",
              "TotalMnthsZeroValidation": "Years and Months both cannot be zero",
              "TotalYrsZeroValidation": "Years and Months both cannot be zero",
              "BackCta": "Back",
              "NextCta": "Next"
          },
          "PreviousResidenceInfo": {
              "AddressLine1invalid": "Previous address Line 1 is invalid",
              "AddressLine1label": "Previous address Line 1",
              "AddressLine1required": "Please provide previous address line 1",
              "AddressLine2invalid": "Previous address Line 2 is invalid",
              "AddressLine2label": "Previous address Line 2",
              "AddressLine2required": "Please provide previous address line 2",
              "CityInvalid": "City is invalid",
              "CityLabel": "City",
              "CityRequired": "Please provide City",
              "ReviewTotolyearMonthTitle": "Total years and months at previous address",
              "StateLabel": "State",
              "StateRequired": "Please select the required",
              "TotalMnthsZeroValidation": "Years and Months both cannot be zero",
              "TotalMonthsLabel": "Total months at address",
              "TotalMonthsRequired": "Please select total months at address",
              "TotalYearsLabel": "Total years at address",
              "TotalYearsRequired": "Please select total years at address",
              "TotalYrsZeroValidation": "Years and Months both cannot be zero",
              "ZipCodeInvalid": "Zip code is invalid",
              "ZipCodeLabel": "Zip code",
              "ZipCodeRequired": "Please provide Zip Code",
              "AddressLine1regExp": "",
              "AddressLine2regExp": "",
              "CityRegExp": "",
              "MonthlyRentMortgageRegExp": "",
              "ZipCodeRegExp": "",
              "BackCta": "Back",
              "Group": "",
              "NextCta": "Next"
          },
          "ResidenceInfo": {
              "AddressLine1invalid": "Address Line 1 is invalid",
              "AddressLine1label": "Address Line 1",
              "AddressLine1required": "Please enter a valid address",
              "AddressLine2invalid": "Address Line 2 is invalid",
              "AddressLine2label": "Address Line 2",
              "CityInvalid": "City is invalid",
              "CityLabel": "City",
              "CityRequired": "Please enter a city",
              "MonthlyRentMortgageLabel": "Monthly rent / mortgage",
              "MonthlyRentMortgageRequired": "Please provide amount",
              "ResidenceTypeLabel": "Residence Type",
              "ResidenceTypeRequired": "Please select residence type",
              "ReviewTotolyearMonthTitle": "Total years and months at address",
              "SameAddressLabel": "Same address as buyer",
              "StateLabel": "State",
              "StateRequired": "Please select  a state",
              "TotalMnthsZeroValidation": "Years and Months both cannot be zero",
              "TotalMonthsLabel": "Total months at address",
              "TotalMonthsRequired": "Please make a selection",
              "TotalYearsLabel": "Total years at address",
              "TotalYearsRequired": "Please make a selection",
              "TotalYrsZeroValidation": "Years and Months both cannot be zero",
              "ZipCodeInvalid": "Zip code is invalid",
              "ZipCodeLabel": "Zip code",
              "ZipCodeRequired": "Please enter a valid zip code",
              "BackCta": "Back",
              "NextCta": "Next"
          },
          "ReviewInformation": {
              "BuyerInitial": "Buyer's full name",
              "BuyerInitialRequired": "Please provide your full name",
              "CoBuyerDisclaimer": "By initialing below, you both certify in accordance with Regulation B that you both intend to apply for joint credit.  If you are married and live in a community property state please complete the Buyer section about yourself and the Co-Buyer section about your spouse.  You must agree to submit this application and your spouse must agree to submit the application only if she/he wishes to be a Co-Applicant.If you are married and live in a community property state please complete the Buyer section about yourself and the Co-Buyer section about your spouse. You must agree to submit this application and your spouse must agree to submit the application only if he/she wishes to be a Co-Applicant. By clicking SUBMIT, you certify that you have completed this application to obtain credit, and that all the information provided by you for this application is true, correct, and complete. You understand and agree that this application and related credit information may be used by us to obtain your credit report and may be forwarded to one or more financial institutions for the purpose of obtaining credit for you and such financial institution may be asked to buy the retail installment contract or lease involved in this transaction. You authorize us to share the results of any credit report, credit investigation, or employment investigation (including the information contained in this application) with the financial institutions with which we normally transact business and any other person to assist us in obtaining an extension of credit for you. You also authorize us to receive copies of such reports and investigations to search for financing with third party lenders on your behalf. You authorize us and our third party lenders to make inquiries and obtain information about you as we deem appropriate, including contacting your credit references and/or your employer, investigating your credit and employment history. If provided your e-mail address on this application, you agree that any communications and correspondence to you from any of the parties to this transaction may be effected by e-mail and you expressly consent to us and to our affiliates using prerecorded/artificial voice messages, text messages, and/or automatic dialing equipment to communicate with you regarding this application or your vehicle transaction and you agree that we may take these actions using the telephone number(s) that you provide us in this credit application, you provide to us in the future, even if the number is for a mobile telephone and/or out using the number results in charges to you.",
              "CoBuyerInitialRequired": "Please provide co-buyer full name",
              "CobuyerIntial": "Co-buyer’s full name",
              "ConsentTitle": "Consent",
              "Disclaimer": "If you are married and live in a community property state please complete the Buyer section about yourself and the Co-Buyer section about your spouse. You must agree to submit this application and your spouse must agree to submit the application only if he/she wishes to be a Co-Applicant. By clicking SUBMIT, you certify that you have completed this application to obtain credit, and that all the information provided by you for this application is true, correct, and complete. You understand and agree that this application and related credit information may be used by us to obtain your credit report and may be forwarded to one or more financial institutions for the purpose of obtaining credit for you and such financial institution may be asked to buy the retail installment contract or lease involved in this transaction. You authorize us to share the results of any credit report, credit investigation, or employment investigation (including the information contained in this application) with the financial institutions with which we normally transact business and any other person to assist us in obtaining an extension of credit for you. You also authorize us to receive copies of such reports and investigations to search for financing with third party lenders on your behalf. You authorize us and our third party lenders to make inquiries and obtain information about you as we deem appropriate, including contacting your credit references and/or your employer, investigating your credit and employment history. If provided your e-mail address on this application, you agree that any communications and correspondence to you from any of the parties to this transaction may be effected by e-mail and you expressly consent to us and to our affiliates using prerecorded/artificial voice messages, text messages, and/or automatic dialing equipment to communicate with you regarding this application or your vehicle transaction and you agree that we may take these actions using the telephone number(s) that you provide us in this credit application, you provide to us in the future, even if the number is for a mobile telephone and/or out using the number results in charges to you.",
              "EditCTA": "Edit",
              "NameLabel": "Name",
              "BankOffersHtml": "<style>\n.brand-promise-row {\n  padding: 0 55px 0 55px;\n}\n\n.name-receiving  p {\n  color: #0A3453;\n  font-size: 16px;\n}\n\n.description-receiving  p {\n  color: #0A3453;\n  font-size: 14px;\n}\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes zoomIn {\n  from {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  from {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n</style>\n\n\n            <div class=\"row mx-0 brand-promise-row\" > \n                <div class=\"animated zoomIn col-4 px-1 px-sm-1 px-md-1 px-lg-3\">\n                    <div class=\"row\">\n                        <div class=\"col text-center\">\n                            <img src=\"/-/media/Images/Autonation/CreditApplication4/brandPromises\" > \n                        </div>\n                    </div>\n                    <div class=\"row m-0 name-receiving\">\n                        <div class=\"col px-0\">\n                            <p class=\"font-weight-bold text-center\">\n                                Easy Credit\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"row m-0 description-receiving\">\n                        <div class=\"col text-center px-0\">\n                            <p class=\"font-weight-normal text-center\">\n                                Regardless of your credit situation, chances are we can find a lender and a program to fit your budget.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n    \n                <div class=\"animated zoomIn col-4 px-1 px-sm-1 px-md-1 px-lg-3\">\n                    <div class=\"row\">\n                        <div class=\"col text-center\">\n                            <img src=\"/-/media/Images/Autonation/CreditApplication4/brandPromises\" > \n                       </div>\n                    </div>\n                    <div class=\"row m-0 name-receiving\">\n                        <div class=\"col px-0\">\n                            <p class=\"font-weight-bold text-center\">\n                                Multiple Lenders\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"row m-0 description-receiving\">\n                        <div class=\"col text-center px-0\">\n                            <p class=\"font-weight-normal text-center\">\n                                Regardless of your credit situation, chances are we can find a lender and a program to fit your budget.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n    \n                <div class=\"animated zoomIn col-4 px-1 px-sm-1 px-md-1 px-lg-3\">\n                    <div class=\"row\">\n                        <div class=\"col text-center\">\n                            <img src=\"/-/media/Images/Autonation/CreditApplication4/brandPromises\" > \n                        </div>\n                    </div>\n                    <div class=\"row m-0 name-receiving\">\n                        <div class=\"col px-0\">\n                            <p class=\"font-weight-bold text-center\">\n                                Full Transparency\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"row m-0 description-receiving\">\n                        <div class=\"col text-center px-0\">\n                            <p class=\"font-weight-normal text-center\">\n                                Regardless of your credit situation, chances are we can find a lender and a program to fit your budget.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n",
              "AdditionalIncome": "Additional income",
              "AdditionalInfo": "Additional info",
              "Cobuyeradditionalincome": "Co-buyer additional income",
              "Cobuyeremployment": "Co-buyer employment information",
              "Cobuyerpersonalinfo": "Co-buyer personal information",
              "Cobuyerreisdenceinfo": "Co-buyer residence information",
              "EmploymentInfo": "Employment information",
              "PersonalInfo": "Personal information",
              "ResideceInfo": "Residence information",
              "ScrollDown": "Scroll Down",
              "BackCta": "Back",
              "NextCta": "Submit"
          },
          "ThankyouInfo": {
              "BuyNowSubTitle": "We will review your financing or lease options based on the credit information you provided.",
              "BuyNowTitle": "Your credit application is complete.",
              "NewApplication": "NEW APPLICATION",
              "Next": "Next",
              "BackCta": "Start Again",
              "NextCta": "Next",
              "ThankyouMessage": "Talk to our Finance Manager to secure your financing and finalize your deal.",
              "ThankyouTitle": "Cross the finish line"
          }
      },
      "GetLowerPriceConfig": {
          "AcceptTextCTA": "UNLOCK SAVINGS",
          "DismissTextCTA": "Continue without lower price",
          "EmailAddressLabel": "Email address",
          "FirstNameLabel": "First name",
          "InvalidErrorMsg": "Please enter a valid ",
          "LastNameLabel": "Last name ",
          "LeadFormSubTitle": "Fill in your details to see a discounted price",
          "LeadFormTitle": "This vehicle is eligible for a lower price",
          "PhoneNumberLabel": "Phone number",
          "RequiredErrorMsg": " is required",
          "ZipCodeLabel": "Zip Code",
          "Name": "GetLowerPriceConfig",
          "phonePlaceholder": "(___) ___-____",
      },
      "PriceDetails": {
          "Header": "PRICE DETAILS",
          "PriceItemsLabels": [
              {
                  "Key": "Accesories",
                  "Value": "Accesories"
              },
              {
                  "Key": "Accessories",
                  "Value": "Accessories"
              },
              {
                  "Key": "Autogear Accesories",
                  "Value": "Autogear Accesories"
              },
              {
                  "Key": "AutonationPrice",
                  "Value": "AutoNation Price"
              },
              {
                  "Key": "Autonation1Price",
                  "Value": "AutoNation 1Price"
              },
              {
                  "Key": "Autonation1PriceTooltipText",
                  "Value": "Our pre-owned vehicles are priced just right. No Haggling. No Pressure. Every 1Price Pre-Owned Vehicle is backed by a 5-Day, 250-Mile Money-Back Guarantee and a CARFAX™ Vehicle History Report. Plus, the price you see online is the same price you will find on our lot. You can even get a pre-owned vehicle that is Quality Certified with a limited warranty. Disclaimer: Money-Back Guarantee is valid for 5 days or 250 miles, whichever comes first. See store for complete guarantee details, some restrictions apply. Transfer fee may apply."
              },
              {
                  "Key": "AutonationSavings",
                  "Value": "AutoNation Savings"
              },
              {
                  "Key": "Balance Due",
                  "Value": "Balance Due"
              },
              {
                  "Key": "BalanceDue",
                  "Value": "Balance Due"
              },
              {
                  "Key": "Certified Value",
                  "Value": "Certified Value"
              },
              {
                  "Key": "DealerFee",
                  "Value": "Dealer Fee"
              },
              {
                  "Key": "DealerFeeTooltipText",
                  "Value": "Dealer fee."
              },
              {
                  "Key": "Difference",
                  "Value": "Difference"
              },
              {
                  "Key": "Fee",
                  "Value": "Fee"
              },
              {
                  "Key": "FinalAppraisalValue",
                  "Value": "Final Appraisal Value"
              },
              {
                  "Key": "LienPayoff",
                  "Value": "Lien Payoff (estimated)"
              },
              {
                  "Key": "MSRP",
                  "Value": "MSRP"
              },
              {
                  "Key": "OtherFee",
                  "Value": "Other Fee"
              },
              {
                  "Key": "Payoff balance",
                  "Value": "Payoff (estimated)"
              },
              {
                  "Key": "ProtectionPackages",
                  "Value": "Protection Packages"
              },
              {
                  "Key": "ProtectionPlan",
                  "Value": "Protection Plan"
              },
              {
                  "Key": "Rebate",
                  "Value": "Rebate"
              },
              {
                  "Key": "Rebates",
                  "Value": "Rebates"
              },
              {
                  "Key": "Recommended",
                  "Value": "Recommended"
              },
              {
                  "Key": "SellingPriceAfterTradeIn",
                  "Value": "Selling Price After Trade-In"
              },
              {
                  "Key": "Tax",
                  "Value": "Estimated Taxes"
              },
              {
                  "Key": "TaxTooltipText",
                  "Value": "Taxes and fees are estimated and may vary."
              },
              {
                  "Key": "TaxesAndFees",
                  "Value": "Taxes And Fees"
              },
              {
                  "Key": "TaxesAndFeesTooltipText",
                  "Value": "Taxes and fees are estimated and may vary."
              },
              {
                  "Key": "Trade-In Value",
                  "Value": "Trade-In Value (Estimated)"
              },
              {
                  "Key": "TradeInAdjustments",
                  "Value": "Trade-In Adjustments"
              },
              {
                  "Key": "TradeInValue",
                  "Value": "Certified Trade-In Value"
              },
              {
                  "Key": "TradeInWithoutConditioning",
                  "Value": "Trade-In Without Conditioning"
              },
              {
                  "Key": "Value without conditioning",
                  "Value": "Value without conditioning"
              },
              {
                  "Key": "VehicleSellingPrice",
                  "Value": "Vehicle Selling Price"
              },
              {
                  "Key": "ViewRebates",
                  "Value": "Select rebates"
              }
          ]
      },
      "VehicleDetailsRailLabels": {
          "Body_Label": "Body Style",
          "Drive_Type_Label": "Drive Type",
          "Engine_Label": "Engine",
          "Exterior_Label": "Exterior",
          "Interior_Label": "Interior",
          "Mileage_Label": "Mileage",
          "MPG_Label": "MPG",
          "Tooltip_Label": "Tooltip",
          "Transmission_Label": "Transmission",
          "View_Details_Label": "View Details",
          "View_Price_Details_Label": "View Pricing Details",
          "Vin_Label": "Vin",
          "GetLowerPrice": "Unlock Savings",
          "DealerFeeTooltip": "This only includes approximate fees",
          "EstimateLabel": "(Estimated)",
          "MRSPToolTip": "Manufacturer Suggested Selling Price",
          "PriceBreakDownTitle": "Price Breakdown",
          "TaxTooltip": "Taxes and fees are estimated and may vary",
          "CPO_Label": {
              "ID": "19d1dca8-fb1a-41f9-ab0c-4f04bbdac3dc",
              "HEX": "#0f3451"
          },
          "New_Label": {
              "ID": "d1b4636e-a773-467e-9f4f-3ccc842bf008",
              "HEX": "#3366cc"
          },
          "Used_Label": {
              "ID": "7023a9ae-fab2-451d-a11c-6a44e47832b5",
              "HEX": "#6c788d"
          },
          "Name": "Prequal Vehicle Details Rail"
      },
      "PricingStackItems": {
          "Autonation1Price": "AutoNation 1Price",
          "Autonation1PriceTooltipText": "Our pre-owned vehicles are priced just right. No Haggling. No Pressure. Every 1Price Pre-Owned Vehicle is backed by a 5-Day, 250-Mile Money-Back Guarantee and a CARFAX™ Vehicle History Report. Plus, the price you see online is the same price you will find on our lot. You can even get a pre-owned vehicle that is Quality Certified with a limited warranty. Disclaimer: Money-Back Guarantee is valid for 5 days or 250 miles, whichever comes first. See store for complete guarantee details, some restrictions apply. Transfer fee may apply."
      },
      "CarPaymentCalculator": {
          "LockUnlockThreshold": 100
      },
      "Meta_Description": "Looking for the best place to find a used or new car online? Browse from millions of car deals everyday with our free search functionality.  Find your car now! ",
      "Meta_Keywords": "The AutoNation inventory of new &amp;amp; used cars, trucks &amp;amp; SUVs is unsurpassed in . Your AutoNation dealer can help you purchase the vehicle of your choice.",
      "UseTier94PriceForLockedView": true,
      "AppointmentStateSitecoreLables": {
          "AppointmentDetails": {
              "AppointmentTitle": "Make An Appointment",
              "TitleIcon": "",
              "ReservationSwithToAppointmentDisable": false,
              "IsLeadFormToBeShownFirst": false,
              "ReservationTitle": "Reserve this vehicle for 24 hours.",
              "NewBGColor": {
                  "ID": "d1b4636e-a773-467e-9f4f-3ccc842bf008",
                  "HEX": "#3366cc"
              },
              "UsedBGColor": {
                  "ID": "7023a9ae-fab2-451d-a11c-6a44e47832b5",
                  "HEX": "#6c788d"
              },
              "CPOBGColor": {
                  "ID": "19d1dca8-fb1a-41f9-ab0c-4f04bbdac3dc",
                  "HEX": "#0f3451"
              },
              "LabelNew": {
                  "VehicleText": "new"
              },
              "LabelUsed": {
                  "VehicleText": "used"
              },
              "LabelCPO": {
                  "VehicleText": "cpo"
              },
              "LazyLoadAllowed": null,
              "LazyLoadDelayMilliseconds": null,
              "ErrorTitle": "",
              "ErrorSubtitle": "",
              "ErrorIcon": "",
              "ErrorCTA": "",
              "AppointmentFailure": "Opps your appointment could not be submitted at this time someone will contact you to confirm an appointment ",
              "AppointmentLeadFailure": "Opps your appointment could not be submitted at this time please contact the store to complete an appointment",
              "ReservationSessionError": "This vehicle is already reserved by another user and I am able to submit an appointment for the store with VOI instead",
              "ReservationStoreInvalidError": "The reservation for your vehicle has failed",
              "ReservationLeadFailure": "Opps your reservation could not be submitted at this time",
              "ReservationFailure": "The reservation for your vehicle has failed. However, you still have an appointment",
              "ExteriorColorLabel": "Exterior Color",
              "InteriorColorLabel": "Interior Color",
              "EngineLabel": "Engine",
              "TransmissionLabel": "Transmission",
              "DriveTypeLabel": "Drive Type",
              "BodyLabel": "Body"
          },
          "AppointmentCTAs": {
              "AppointmentCTALabel": "Submit",
              "AddToCalendarCTA": "Add To Calendar",
              "BuildYourDealCTA": "Get Started",
              "BackCTA": "Back",
              "NextCTA": "Next",
              "AppointmentCTABGColor": "linear-gradient(to right, var(--pink-600) 0%, #EF73AB 90%)",
              "AddToCalendarCTABGColor": "",
              "BuildYourDealCTABGColor": "",
              "BackCTABGColor": "",
              "NextCTABGColor": "linear-gradient(to right, var(--pink-600) 0%, #EF73AB 90%)",
              "GoogleCalendarCTA": "Google Calendar",
              "YahooCalendarCTA": "Yahoo Calendar",
              "OutlookCalendarCTA": "Outlook Calendar"
          },
          "AppointmentCalendar": {
              "MainTitle": "Schedule your pickup at store",
              "DayTimeSelectLabel": "No obligation or deposit needed.",
              "PreferedTimeTitle": null,
              "NoHoursAvailableText": "No hours available to schedule an appointment. Please select another date.",
              "NumberOfSelectableDays": "7",
              "NumberOfSelectableDaysReservation": "1",
              "CalendarCurrentDayText": "Today",
              "TimeInterval": "15",
              "OutScopeDate": "Scheduling an appointment outside of the 24-hour reservation window will not guarantee that your vehicle will be available.",
              "NoDateSelectionIsMadeValidation": "Please select an hour or other date.",
              "InvalidSelectionIsMadeValidation": "Please select an hour or other date.",
              "LongerPeriodAppointmentMessageText": "To guarantee no one can claim this car",
              "LongerPeriodAppointmentCTALabel": "Make a Reservation",
              "LongerPeriodReservationMessageText": "Need Longer Period of time?",
              "LongerPeriodReservationCTALabel": "Make an Appointment",
              "VehicleReservedByAnotherUserText": "Oh no, looks like someone has already reserved this vehicle. You will only be able to make appointment at this time.",
              "UserAlreadyReservedVehicleText": "Oh no, looks like you already have an active Reservation. You will only be able to make appointment at this time.",
              "VehicleNotReservableText": "Oh no, looks like this vehicle is not available for reservation. You will only be able to make appointment at this time.",
              "VehicleNotAvailable": "Oh no, looks like this vehicle is not available in inventory.  You will only be able to make appointment at this time. ",
              "vehicleInTransit": "Oh no, looks like this vehicle is in transit.  You will only be able to make appointment at this time. ",
              "InterestedHomeDelivery": "Interested in home delivery?",
              "MoreTimeText": "Need more time?",
              "MoreTimeIcon": {
                  "Alt": "",
                  "Border": "",
                  "Class": "",
                  "Height": 0,
                  "HSpace": 0,
                  "Src": null,
                  "VSpace": 0,
                  "Width": 0,
                  "MediaId": "c19126b8-bf8d-4a73-928c-2c56f186b531",
                  "Title": null,
                  "Language": {
                      "Name": "en"
                  },
                  "MediaExists": false
              },
              "ContactStore": "Contact Store",
              "IsHomeDeliveryDisabled": false,
              "IsHomeDeliveryUncheckedByDefault": true,
              "HomeDeliveryTooltip": "Our Associates will guide you through every step of the experience using online tools. You can start online and finish in store or start in store and finish online. You pick. We believe that you deserve the freedom to choose the experience that works best for you. Shop, buy and sell all from the convenience of any location you choose."
          },
          "AppointmentLeadForm": {
              "LeadFormMainTitle": "Enter Delivery Details",
              "LeadFormTitle": "Give Us A Few Details About Yourself",
              "FirstName": "First Name",
              "LastName": "Last Name",
              "EmailAddress": "Email Address",
              "PhoneNumber": "Phone Number",
              "ZipCode": "Zip Code",
              "LeadFirstNamePlaceholder": "Your First Name",
              "LeadLastNamePlaceholder": "Your Last Name",
              "LeadEmailAddressPlaceholder": "Your Email Address",
              "LeadPhoneNumberPlaceholder": "Your Phone Number",
              "LeadZipCodePlaceholder": "Your Zip Code",
              "FirstNameRequired": "Please enter the first name.",
              "FirstNameInvalid": "Please enter valid First Name.",
              "LasttNameRequired": "Please enter the Last Name.",
              "LasttNameInvalid": "Please enter valid Last Name.",
              "EmailAddressRequired": "Please enter the Email Address.",
              "EmailAddressInvalid": "Please enter valid Email Address.",
              "PhoneNumberRequired": "Enter phone number.",
              "PhoneNumberInvalid": "Please enter valid Phone Number.",
              "PhoneNumberLengthInvalid": "Please enter 10 digit number",
              "ZipCodeRequired": "Enter zip code.",
              "ZipCodeInvalid": "Please enter valid Zip Code.",
              "GenericError": "There has been an error creating this appointment.",
              "CouldNotCreateAppointment": "The appointment could not be created.",
              "ScheduleSameDayError": "You already have an active appointment, Please select a different date & time.",
              "DateAndTimeRequired": "Please select a Date Time",
              "CouldNotCompleteReservation": "Could not complete the reservation.",
              "ReservationFailedFromCompass": "Reservation failed from Compass end.",
              "ReservationFailedFromInventory": "Reservation failed from Inventory.",
              "Address": "Delivery Address",
              "City": "City",
              "State": "State",
              "AddressPlaceholder": "Delivery Address",
              "CityPlaceholder": "City",
              "AddressRequired": "Please enter the address.",
              "AddressInvalid": "Please enter a valid address.",
              "CityRequired": "Please enter the city.",
              "CityInvalid": "Please enter a valid city.",
              "StateRequired": "Please select the State.",
              "StateInvalid": "Please select a valid State.",
              "StandAlonePrequalErrorIcon": "",
              "StandAlonePrequalErrorTitle": "Something is jacked up",
              "StandAlonePrequalErrorSubTitle": "Sorry, there was a problem with your request."
          },
          "AppointmentStoreDetails": {
              "StoreDetailsTitle": "Reserve this vehicle for up to 2 days",
              "StoreHoursLabel": "Store Hours",
              "StorePhoneNumberIcon": "",
              "StoreLocationIcon": ""
          },
          "AppointmentConfirmation": {
              "AppointmentConfirmationTitle": "Your Appointment is Set!",
              "AppointmentConfirmationIcon": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\"><defs><style>.a{fill:#0a3453;}</style></defs><g transform=\"translate(-40 -123.5)\"><g transform=\"translate(40 123.5)\"><path class=\"a\" d=\"M26.95,28A13.05,13.05,0,1,1,40,41.05,13.059,13.059,0,0,1,26.95,28M25,28A15,15,0,1,0,40,13,15.044,15.044,0,0,0,25,28\" transform=\"translate(-25 -13)\"/><path class=\"a\" d=\"M42.825,20.071l-7.35,7.5-3.75-3.6a.742.742,0,0,0-1.05,1.05l4.35,4.05a.551.551,0,0,0,.45.15c.15,0,.45-.15.6-.15l7.95-7.95a.725.725,0,0,0,0-1.05c-.15-.15-.3-.15-.6-.15-.15-.15-.45,0-.6.15\" transform=\"translate(-22.275 -9.571)\"/></g></g></svg>",
              "ConfirmationMessage": "We'll see you soon.",
              "ConfirmationDetailsTitle": "Appointment Details",
              "ConfirmationDateTimeFormat": "dddd, dd MMMM yyyy @ hh:mm tt",
              "BuildYourDealTitle": "Build Your Deal",
              "BuildYourDealMessage": "With My AutoNation, you have the power to customize the way you buy your next car.",
              "LegalDisclaimer": "While AutoNation makes every effort to ensure your vehicle is available for you at your appointment time, there may be circumstances where a vehicle is unavailable. We will take reasonable efforts to let you know in advance and a sales associate will work with you to find a suitable replacement.",
              "ReservationConfirmationTitle": null,
              "ReservationExpireMessage": "Expires on [DAY], [MONTH] [DATE] at [TIME]",
              "ShowExpirationDate": true,
              "ReservationConfirmationIcon": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22.75\" height=\"35\" viewBox=\"0 0 22.75 35\"><defs><style>.a{fill:#0a3453;}</style></defs><g transform=\"translate(-320 -183)\"><g transform=\"translate(320 194.968)\"><path class=\"a\" d=\"M11.375,34.132a11.517,11.517,0,0,1,0-23.032,11.517,11.517,0,0,1,0,23.032Zm0-21.339a9.823,9.823,0,0,0,0,19.645,9.823,9.823,0,0,0,0-19.645Z\" transform=\"translate(0 -11.1)\"/></g><g transform=\"translate(323.281 183)\"><path class=\"a\" d=\"M18.229,15.948a.891.891,0,0,1-.9-.9V7.9a6.21,6.21,0,0,0-12.419,0v7.141a.891.891,0,0,1-.9.9.831.831,0,0,1-.9-.9V7.9a7.9,7.9,0,0,1,15.806,0v7.141A.723.723,0,0,1,18.229,15.948Z\" transform=\"translate(-3.1)\"/></g><g transform=\"translate(329.568 203.37)\"><path class=\"a\" d=\"M10.406,18.4A1.783,1.783,0,0,0,8.6,20.206a1.8,1.8,0,0,0,.9,1.581v2.258a.891.891,0,0,0,.9.9h.113a.891.891,0,0,0,.9-.9V21.787a1.8,1.8,0,0,0,.9-1.581A1.959,1.959,0,0,0,10.406,18.4Z\" transform=\"translate(-8.6 -18.4)\"/></g></g></svg>",
              "ReservationConfirmationHold": "We’ll hold onto your vehicle for 24 hours and we’ll see you on",
              "EnableEditAppointment": false,
              "EditAppointmentLabel": "Need to change your appointment?",
              "EditAppointmentCTA": "Edit appointment",
              "EditAppointmentIcon": {
                  "Alt": "",
                  "Border": "",
                  "Class": "",
                  "Height": 0,
                  "HSpace": 0,
                  "Src": null,
                  "VSpace": 0,
                  "Width": 0,
                  "MediaId": "d19ac830-6b67-46f9-ad96-fa76bf1b3012",
                  "Title": null,
                  "Language": {
                      "Name": "en"
                  },
                  "MediaExists": false
              },
              "VisitANCom": "Visit AutoNation.com",
              "ReservationBrandPromiseIcon": null,
              "ReservationBrandPromiseTitle": "Mega selection",
              "ReservationBrandPromiseDescription": "With over 100,000 new and pre-owned cars, trucks, vans & sport utilities, we have the vehicle you’re looking for.",
              "CancelReservationLink": "Cancel reservation",
              "ReservationCancelLabel": "Your reservation has been cancelled. ",
              "AppointmentRemainLabel": "Your appointment remains for:",
              "StandAloneTradeCTALabel": "Do you have a trade?",
              "StandAlonePreQualifiedCTALabel": ""
          },
          "reservationData": {
              "ReservationDuration": 24,
              "ReservationStatus": 0,
              "StatusMessage": "This vehicle is reservable."
          },
          "AppointmentAndReservationEnabled": true
      },
      "CreditAppBannerContent": {},
      "LookupMappingInformation": [
          {
              "LookupName": "StateCodeType",
              "Mappings": [
                  {
                      "Details": "Alabama",
                      "Value": "AL",
                      "Description": "AL"
                  },
                  {
                      "Details": "Alaska",
                      "Value": "AK",
                      "Description": "AK"
                  },
                  {
                      "Details": "Arizona",
                      "Value": "AZ",
                      "Description": "AZ"
                  },
                  {
                      "Details": "Arkansas",
                      "Value": "AR",
                      "Description": "AR"
                  },
                  {
                      "Details": "American Samoa",
                      "Value": "AS",
                      "Description": "AS"
                  },
                  {
                      "Details": "California",
                      "Value": "CA",
                      "Description": "CA"
                  },
                  {
                      "Details": "Colorado",
                      "Value": "CO",
                      "Description": "CO"
                  },
                  {
                      "Details": "Connecticut",
                      "Value": "CT",
                      "Description": "CT"
                  },
                  {
                      "Details": "Delaware",
                      "Value": "DE",
                      "Description": "DE"
                  },
                  {
                      "Details": "District of Columbia",
                      "Value": "DC",
                      "Description": "DC"
                  },
                  {
                      "Details": "Florida",
                      "Value": "FL",
                      "Description": "FL"
                  },
                  {
                      "Details": "Georgia",
                      "Value": "GA",
                      "Description": "GA"
                  },
                  {
                      "Details": "Guam",
                      "Value": "GU",
                      "Description": "GU"
                  },
                  {
                      "Details": "Hawaii",
                      "Value": "HI",
                      "Description": "HI"
                  },
                  {
                      "Details": "Idaho",
                      "Value": "ID",
                      "Description": "ID"
                  },
                  {
                      "Details": "Illinois",
                      "Value": "IL",
                      "Description": "IL"
                  },
                  {
                      "Details": "Indiana",
                      "Value": "IN",
                      "Description": "IN"
                  },
                  {
                      "Details": "Iowa",
                      "Value": "IA",
                      "Description": "IA"
                  },
                  {
                      "Details": "Kansas",
                      "Value": "KS",
                      "Description": "KS"
                  },
                  {
                      "Details": "Kentucky",
                      "Value": "KY",
                      "Description": "KY"
                  },
                  {
                      "Details": "Louisiana",
                      "Value": "LA",
                      "Description": "LA"
                  },
                  {
                      "Details": "Maine",
                      "Value": "ME",
                      "Description": "ME"
                  },
                  {
                      "Details": "Maryland",
                      "Value": "MD",
                      "Description": "MD"
                  },
                  {
                      "Details": "Massachusetts",
                      "Value": "MA",
                      "Description": "MA"
                  },
                  {
                      "Details": "Michigan",
                      "Value": "MI",
                      "Description": "MI"
                  },
                  {
                      "Details": "Minnesota",
                      "Value": "MN",
                      "Description": "MN"
                  },
                  {
                      "Details": "Mississippi",
                      "Value": "MS",
                      "Description": "MS"
                  },
                  {
                      "Details": "Missouri",
                      "Value": "MO",
                      "Description": "MO"
                  },
                  {
                      "Details": "Montana",
                      "Value": "MT",
                      "Description": "MT"
                  },
                  {
                      "Details": "Nebraska",
                      "Value": "NE",
                      "Description": "NE"
                  },
                  {
                      "Details": "Nevada",
                      "Value": "NV",
                      "Description": "NV"
                  },
                  {
                      "Details": "New Hampshire",
                      "Value": "NH",
                      "Description": "NH"
                  },
                  {
                      "Details": "New Jersey",
                      "Value": "NJ",
                      "Description": "NJ"
                  },
                  {
                      "Details": "New Mexico",
                      "Value": "NM",
                      "Description": "NM"
                  },
                  {
                      "Details": "New York",
                      "Value": "NY",
                      "Description": "NY"
                  },
                  {
                      "Details": "North Carolina",
                      "Value": "NC",
                      "Description": "NC"
                  },
                  {
                      "Details": "North Dakota",
                      "Value": "ND",
                      "Description": "ND"
                  },
                  {
                      "Details": "Northern Mariana Islands",
                      "Value": "MP",
                      "Description": "MP"
                  },
                  {
                      "Details": "Ohio",
                      "Value": "OH",
                      "Description": "OH"
                  },
                  {
                      "Details": "Oklahoma",
                      "Value": "OK",
                      "Description": "OK"
                  },
                  {
                      "Details": "Oregon",
                      "Value": "OR",
                      "Description": "OR"
                  },
                  {
                      "Details": "Pennsylvania",
                      "Value": "PA",
                      "Description": "PA"
                  },
                  {
                      "Details": "Puerto Rico",
                      "Value": "PR",
                      "Description": "PR"
                  },
                  {
                      "Details": "Rhode Island",
                      "Value": "RI",
                      "Description": "RI"
                  },
                  {
                      "Details": "South Carolina",
                      "Value": "SC",
                      "Description": "SC"
                  },
                  {
                      "Details": "South Dakota",
                      "Value": "SD",
                      "Description": "SD"
                  },
                  {
                      "Details": "Tennessee",
                      "Value": "TN",
                      "Description": "TN"
                  },
                  {
                      "Details": "Texas",
                      "Value": "TX",
                      "Description": "TX"
                  },
                  {
                      "Details": "Trust Territories",
                      "Value": "TT",
                      "Description": "TT"
                  },
                  {
                      "Details": "Utah",
                      "Value": "UT",
                      "Description": "UT"
                  },
                  {
                      "Details": "Vermont",
                      "Value": "VT",
                      "Description": "VT"
                  },
                  {
                      "Details": "Virginia",
                      "Value": "VA",
                      "Description": "VA"
                  },
                  {
                      "Details": "Virgin Islands",
                      "Value": "VI",
                      "Description": "VI"
                  },
                  {
                      "Details": "Washington",
                      "Value": "WA",
                      "Description": "WA"
                  },
                  {
                      "Details": "West Virginia",
                      "Value": "WV",
                      "Description": "WV"
                  },
                  {
                      "Details": "Wisconsin",
                      "Value": "WI",
                      "Description": "WI"
                  },
                  {
                      "Details": "Wyoming",
                      "Value": "WY",
                      "Description": "WY"
                  }
              ]
          }
      ],
      "ANXTransactionFlags": {
          "isAppointmentandReservationEnabled": true,
          "isCFSAccessEnabled": true,
          "isPaymentCalculatorEnabled": true,
          "isWBYCAccessEnabled": true,
          "isPreQualificationEnabled": true,
          "isLeadFormEnabled": true,
          "isBuyNowEnabled": true,
          "dealerItemID": "{7EF99941-63A5-4AEB-91DB-9C62B48548D4}"
      },
      "LeadInfo": {
          "FirstName": null,
          "LastName": null,
          "EmailAddress": null,
          "HomePhone": null,
          "ZipCode": "58772",
          "LeadId": null,
          "isDashboard": false
      },
      "CreditApplication": "",
      "CreditApplicationInfo": null,
      "StoreInfo": {
          "HasInventory": true,
          "HyperionId": "2025",
          "Name": "AutoNation Ford Westlake",
          "Address": {
              "AddressLine1": "23775 Center Ridge Rd",
              "AddressLine2": null,
              "City": "Westlake",
              "StateCode": "OH",
              "PostalCode": "44145"
          },
          "MainPhone": "(844) 360-2670",
          "StoreUrl": "https://www.autonation.com/dealers/ford-westlake-oh",
          "ServiceIcons": "R,S",
          "CollisionUrl": "",
          "VideoProvider": "Unity Works",
          "CCID": "CC155289",
          "BrandsForFiltering": "Ford",
          "Longitude": "-81.884817",
          "Latitude": "41.456593",
          "MarketDNS": "Midwest & Northeast",
          "PartsUrl": "https://www.autonation.com/dealers/ford-westlake-oh",
          "DesktopSeoPhoneNumber": "",
          "MobileSeoPhoneNumber": "",
          "ServiceAppointmentProvider": "CDK",
          "ServiceAppointmentProviderUrl": "https://service.connectcdk.com?cid=2500448&hid=2025",
          "DetailedHours": [
              {
                  "Day": 0,
                  "StartTime": "9:00 AM",
                  "EndTime": "9:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 1,
                  "StartTime": "9:00 AM",
                  "EndTime": "9:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 2,
                  "StartTime": "9:00 AM",
                  "EndTime": "9:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 3,
                  "StartTime": "9:00 AM",
                  "EndTime": "9:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 4,
                  "StartTime": "9:00 AM",
                  "EndTime": "9:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 5,
                  "StartTime": "9:00 AM",
                  "EndTime": "6:00 PM",
                  "Reoccurence": 0
              },
              {
                  "Day": 6,
                  "StartTime": "11:00 AM",
                  "EndTime": "5:00 PM",
                  "Reoccurence": 0
              }
          ],
          "Departments": [
              {
                  "Name": "Sales",
                  "Hours": "Mo-Fr: 9:00am-9:00pm, Sa: 9:00am-6:00pm, Su: 11:00am-5:00pm",
                  "ContactName": null,
                  "ContactPhone": "",
                  "ContactEmail": null,
                  "DepartmentType": "Sales",
                  "DetailedHours": [
                      {
                          "Day": 0,
                          "StartTime": "9:00 AM",
                          "EndTime": "9:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 1,
                          "StartTime": "9:00 AM",
                          "EndTime": "9:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 2,
                          "StartTime": "9:00 AM",
                          "EndTime": "9:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 3,
                          "StartTime": "9:00 AM",
                          "EndTime": "9:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 4,
                          "StartTime": "9:00 AM",
                          "EndTime": "9:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 5,
                          "StartTime": "9:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 6,
                          "StartTime": "11:00 AM",
                          "EndTime": "5:00 PM",
                          "Reoccurence": 0
                      }
                  ],
                  "Brands": "Ford"
              },
              {
                  "Name": "Service",
                  "Hours": "Mo-Fr: 7:00am-6:00pm, Sa: 8:00am-4:00pm, Su: Closed",
                  "ContactName": null,
                  "ContactPhone": "",
                  "ContactEmail": null,
                  "DepartmentType": "Service",
                  "DetailedHours": [
                      {
                          "Day": 0,
                          "StartTime": "7:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 1,
                          "StartTime": "7:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 2,
                          "StartTime": "7:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 3,
                          "StartTime": "7:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 4,
                          "StartTime": "7:00 AM",
                          "EndTime": "6:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 5,
                          "StartTime": "8:00 AM",
                          "EndTime": "4:00 PM",
                          "Reoccurence": 0
                      },
                      {
                          "Day": 6,
                          "StartTime": "",
                          "EndTime": "",
                          "Reoccurence": 0
                      }
                  ],
                  "Brands": "Ford"
              }
          ],
          "DealerSites": [
              {
                  "Description": "Ford Site",
                  "Value": "https://www.autonationfordwestlake.com/"
              }
          ],
          "Brands": "Ford",
          "ServiceLevel": null,
          "Rental": "false",
          "Towing": "false",
          "TimeZoneInfo": {
              "TimeZoneName": "EDT",
              "TimeZoneFullName": "Eastern Daylight Time",
              "OffsetSeconds": -14400
          },
          "AvailableBrands": [
              {
                  "Type": 0,
                  "DistanceAndBrands": {
                      "Distance": 10,
                      "Brands": "Ford"
                  }
              },
              {
                  "Type": 1,
                  "DistanceAndBrands": {
                      "Distance": 30,
                      "Brands": "Acura|Alfa Romeo|Audi|Bentley|BMW|Buick|Cadillac|Chevrolet|Chrysler|Dodge|FIAT|Ford|GMC|Honda|Hyundai|Infiniti|Jaguar|Jeep|Land Rover|Lexus|Lincoln|Maserati|Mazda|Mercedes|Mercedes-Benz|Mercury|MINI|Mitsubishi|Nissan|Porsche|Ram|Scion|Smart|Subaru|Toyota|Volkswagen|Volvo|Genesis|Aston Martin"
                  }
              },
              {
                  "Type": 2,
                  "DistanceAndBrands": {
                      "Distance": 20,
                      "Brands": "Ford"
                  }
              }
          ]
      },
      "IsPrequalification": true,
      "IsContactStore": false,
      "isBuyNow": true,
      "isIframe": false,
      "IsStandAlonePreQual": false,
      "PreQualLeadInfo": {
          "vin": "1FMUK8KH2SGA18504",
          "HyperianId": "2025",
          "inventoryType": "NEW",
          "make": "Ford",
          "year": 2025,
          "model": "Explorer",
          "styleName": "ST-Line 4WD",
          "vehicleImage": "//az336639.vo.msecnd.net/actualcdn/68116dd64a6c4bf0983621460c63f495_635x475_Q75_V4.jpg",
          "firstName": null,
          "lastName": null,
          "middleInitial": "",
          "email": null,
          "phone": null,
          "zipcode": "58772",
          "address": "",
          "address2": "",
          "city": "",
          "state": "",
          "dob": "",
          "ishomedelivery": false,
          "leadid": "",
          "UserPreferredCoordinates": {
              "Longitude": -102.5498,
              "Latitude": 48.9953
          }
      },
      "Config": {
          "PageType": 2,
          "TealiumSettings": {
              "DY_ENVIRONMENT_ID": 8771574,
              "TealiumAccount": "autonation",
              "TealiumProfile": "sitecorean",
              "TealiumENV": "dev"
          }
      },
      ContactStoreLabel: {
        "ConfirmationLogo" : "/~/media/Images/AutonationCom/BuyNow/vehicleNotAvailable-img.svg",
        "ConfirmationTitle" : "Thank you! An associate will contact you soon.",
        "ConfirmationSubTitle" : "You can now close this tab.",
        "Header": {
          "LogoAlt": "Autonation",
          "Of": "of",
          "GetSupport": "Get support",
          "StoreHoursFormat": "{starttime} - {endtime}",
          "StoreHours": "Store hours",
          "Today": "Today",
          "Closed": "Closed",
          "VideoCallWithExpert": "Video call with a protection expert",
          "ChatWithUs": "Chat with us",
          "DisableVideoSupport": true,
          "DisableChatSupport": false,
          "DisablePhoneSupport": false,
          "DisableAddressSupport": false,
          "NavigationHamburgerIcon": false,
          "NavigationCloseIcon": false
        },
        "inventoryStatus": [
          "S",
          "T",
          "ANR"
        ],
        "ContactStoreTitle": "Tell Us few details to get started.",
        "ContactStoreSubtitle": "An associate will be in touch to help you estimate payments or start your purchase.",
        "ContactStoreSubmit": "Submit",
        "SecurelyText": "Information submitted securely.",
        "Email": "Email",
        "EmailInvalidError": "Email is invalid",
        "EmailRequiredError": "Please enter email",
        "FirstName": "First name",
        "FirstNameInvalidError": "First name is invalid",
        "FirstNameRequiredError": "Please enter first name",
        "LastName": "Last name ",
        "LastNameInvalidError": "Last name is invalid",
        "LastNameRequiredError": "Please enter last name",
        "MiddleName": "MI (optional)",
        "MIInvalid": "Invalid MI",
        "Phone": "Phone",
        "PhoneInvalidError": "Phone is Invalid",
        "PhoneRequiredError": "Phone is required",
        "PhoneInvalidAreaCode": "Valid US area codes start with 2-9",
        "Zipcode": "Zip code",
        "ZipCodeInvalidError": "Zipcode is Invalid",
        "ZipCodeRequiredError": "Please enter zip code",
        "JackedCTA": "OK",
        "JackedImage": "/~/media/Images/Autonation/CreditApplication/jackedImage.svg",
        "JackedMessage": "Sorry, there was a problem with your request. Please try again later.",
        "JackedTitle": "Something is jacked up",
      },
      "PreQualTransactionInfo": null,
      "BingKey": "lrn_i7G7DyMSuD1yIpdixRuJ_vfC7xz03tHDGawzYss",
      "UserPreferredCoordinates": {
          "Longitude": -102.5498,
          "Latitude": 48.9953
      },
      "isBuyNowVinInValid": false,
      "ChromeVinDetails": null,
      "IsAzureMapsEnabled": true,
      "isHeadless": true,
      "apiDomain":'',
      azKey:'',
      azApi:'',
      bingKey: '',
      bingLocations: '',
      "isStandAlonePrequal": false,
      "isLegacyCreditApp": false,
      "PricingStack": {
          "Items": [
              {
                  "Name": "AutonationPrice",
                  "Value": 51865.22,
                  "LowestName": "AutonationPrice",
                  "LowestValue": 51865.22,
                  "SortOrder": 4,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "VehicleSellingPrice",
                  "Value": 51865.22,
                  "LowestName": "VehicleSellingPrice",
                  "LowestValue": 51865.22,
                  "SortOrder": 7,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Difference",
                  "Value": 51865.22,
                  "LowestName": "Difference",
                  "LowestValue": 51865.22,
                  "SortOrder": 9,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "BalanceDue",
                  "Value": 54888.66,
                  "LowestName": "BalanceDue",
                  "LowestValue": 54888.66,
                  "SortOrder": 14,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Msrp",
                  "Value": 53740,
                  "LowestName": "Msrp",
                  "LowestValue": 53740,
                  "SortOrder": 0,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Dealer Fee",
                  "Value": 0,
                  "LowestName": "Dealer Fee",
                  "LowestValue": 0,
                  "SortOrder": 1,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "AutonationSavings",
                  "Value": 1874.78,
                  "LowestName": "AutonationSavings",
                  "LowestValue": 1874.78,
                  "SortOrder": 3,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Trade-In Value",
                  "Value": 0,
                  "LowestName": "Trade-In Value",
                  "LowestValue": 0,
                  "SortOrder": 8,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Payoff balance",
                  "Value": 0,
                  "LowestName": "Payoff balance",
                  "LowestValue": 0,
                  "SortOrder": 10,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Tax",
                  "Value": 2612.94,
                  "LowestName": "Tax",
                  "LowestValue": 2612.94,
                  "SortOrder": 11,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Registration Fee",
                  "Value": 143.5,
                  "LowestName": "Registration Fee",
                  "LowestValue": 143.5,
                  "SortOrder": 12,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Title Fee",
                  "Value": 5,
                  "LowestName": "Title Fee",
                  "LowestValue": 5,
                  "SortOrder": 12,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Vendor Fee",
                  "Value": 12,
                  "LowestName": "Vendor Fee",
                  "LowestValue": 12,
                  "SortOrder": 12,
                  "ItemDisplayMode": "lock"
              },
              {
                  "Name": "Dealer Fee",
                  "Value": 250,
                  "LowestName": "Dealer Fee",
                  "LowestValue": 250,
                  "SortOrder": 13,
                  "ItemDisplayMode": "lock"
              }
          ]
      },
      "SubPage": "contact-store",
      "Hid": "2025",
      "TealiumSettings": {
          "TealiumAccount": "autonation",
          "TealiumProfile": "sitecorean",
          "TealiumENV": "dev"
      },
      "SavedVehiclesVin": [],
      "IsSST": false,
      "IsANXInstore": false,
      "UserPreQualifiedInfo": {
          "CreditAppStatus": 0,
          "MaxAmount": 0,
          "UserFirstName": "",
          "UserLastName": ""
      },
      "leftRailVehicleData": {
          "Vin": "1FMUK8KH2SGA18504",
          "Year": 2025,
          "Make": "Ford",
          "Model": "Explorer",
          "Trim": "ST Line",
          "MSRP": 53740,
          "MSRPAdv": 53740,
          "StyleName": "ST-Line 4WD",
          "Mileage": 6,
          "ExteriorColor": "Carbonized Gray Metallic",
          "JDPowered": false,
          "AccessoriesTotal": 0,
          "ANVehicleID": "587C28482608BA452DF75AC7113CC1E5EBA26275C129FD1B096C98221B071E49",
          "Basis": "",
          "VehicleId": 5384910,
          "InteriorTrimType": "Premium Synthetic Seats",
          "InteriorColor": "Onyx",
          "FuelType": "Gasoline Fuel",
          "FuelEconomyHwy": 0,
          "FuelEconomyCity": 0,
          "ExteriorGenericColor": "Gray",
          "eVehicle": false,
          "EngineCylinders": 4,
          "Engine": "2.3L 4 Cylinder Engine Turbocharged",
          "DriveType": "Four Wheel Drive",
          "DiscountPercentage": 0,
          "DiscountAmount": 0,
          "BodyType": [
              "SUV"
          ],
          "ChromeStyleId": 454038,
          "Transmission": "Automatic",
          "WindowsStickerURL": "",
          "InstalledOptions": [
              {
                  "Header": "ENGINE",
                  "DescriptionValue": [
                      {
                          "Description": "ENGINE: 2.3L ECOBOOST I-4 -inc: auto start-stop technology (STD) ",
                          "Value": "99H"
                      }
                  ]
              },
              {
                  "Header": "TRANSMISSION",
                  "DescriptionValue": [
                      {
                          "Description": "TRANSMISSION: 10-SPEED AUTOMATIC (STD) ",
                          "Value": "44T"
                      }
                  ]
              },
              {
                  "Header": "OPTION PACKAGE",
                  "DescriptionValue": [
                      {
                          "Description": "EQUIPMENT GROUP 300A STANDARD PACKAGE ",
                          "Value": "300A"
                      }
                  ]
              },
              {
                  "Header": "PRIMARY PAINT",
                  "DescriptionValue": [
                      {
                          "Description": "CARBONIZED GRAY METALLIC ",
                          "Value": "M7"
                      }
                  ]
              },
              {
                  "Header": "SEAT TYPE",
                  "DescriptionValue": [
                      {
                          "Description": "ONYX, HEATED ACTIVEX SEAT MATERIAL CAP CHAIRS -inc: cloth inserts, red stitching, 8-way power driver w/memory (power function for tilt, lumbar and recline) and 6-way power front passenger (power function for lumbar and recline) ",
                          "Value": "EW-2"
                      },
                      {
                          "Description": "ONYX, HEATED ACTIVEX SEAT MATERIAL CAPTAIN'S CHAIRS -inc: cloth inserts, red stitching, 8-way power driver w/memory (power function for tilt, lumbar and recline) and 6-way power front passenger (power function for lumbar and recline) ",
                          "Value": "EW-1"
                      }
                  ]
              },
              {
                  "Header": "ADDITIONAL EQUIPMENT",
                  "DescriptionValue": [
                      {
                          "Description": "ST-LINE STREET PACK -inc: Wheels: 21\" Magnetite-Painted Aluminum, Tires: P275/45R21 AS BSW, Performance Brakes, Red Painted Perf Front & Rear Brake Calipers ",
                          "Value": "68P"
                      },
                      {
                          "Description": "PREMIUM PACKAGE -inc: cloth inserts, red stitching, 8-way power driver w/memory (power function for tilt, lumbar and recline) and 6-way power front passenger (power function for lumbar and recline), 110V/150W AC Power Outlet, Replaces the powerpoint port on the rear side of the center floor console, Heated ActiveX Seat Material Cap Chairs, cloth inserts, red stitching, 8-way power driver w/memory (power function for tilt, lumbar and recline) and 6-way power front passenger (power function for lumbar and recline), Auto-Dimming Interior Rearview Mirror, Power Tilt/Telescoping Steering Column, Power-Folding Sideview Mirrors w/Autofold, power and heated glass, LED turn signal indicators, security approach lamps, driver's side auto-dimming and driver and passenger side memory, Rain-Sensing Wipers (Front Only), Ambient Lighting, Wireless Charging Pad, 2nd Row Heated Seats ",
                          "Value": "68L"
                      },
                      {
                          "Description": "PANORAMIC VISTA ROOF W/POWER SHADE -inc: remote control front windows (opens front windows from outside of the vehicle via the key fob) ",
                          "Value": "439"
                      },
                      {
                          "Description": "2ND ROW CAPTAIN'S CHAIRS W/E-Z ENTRY & ARMREST -inc: E-Z entry is manually activated, Replaces standard 2nd row captain's chairs ",
                          "Value": "17H"
                      },
                      {
                          "Description": "FRONT & 2ND ROWS FLOOR LINERS W/CARPET FLOOR MATS -inc: front and 2nd rows black carpet floor mats ",
                          "Value": "16B"
                      }
                  ]
              }
          ],
          "StandardEquipment": [
              {
                  "Header": "MECHANICAL",
                  "DescriptionValue": [
                      {
                          "Description": "MECHANICAL",
                          "Value": "Engine: 2.3L EcoBoost I-4 -inc: auto start-stop technology"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Transmission: 10-Speed Automatic"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "3.58 Non-Limited Slip Rear Axle"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "50 State Emissions System"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Transmission w/Driver Selectable Mode"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Automatic Full-Time Four-Wheel Drive"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Battery w/Run Down Protection"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Regenerative Alternator"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Class III Towing Equipment -inc: Hitch and Trailer Sway Control"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Trailer Wiring Harness"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "2 Skid Plates"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Gas-Pressurized Shock Absorbers"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Front And Rear Anti-Roll Bars"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Electric Power-Assist Speed-Sensing Steering"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "18.6 Gal. Fuel Tank"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Quasi-Dual Stainless Steel Exhaust"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Auto Locking Hubs"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Strut Front Suspension w/Coil Springs"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "Multi-Link Rear Suspension w/Coil Springs"
                      },
                      {
                          "Description": "MECHANICAL",
                          "Value": "4-Wheel Disc Brakes w/4-Wheel ABS, Front And Rear Vented Discs, Brake Assist, Hill Descent Control, Hill Hold Control and Electric Parking Brake"
                      }
                  ]
              },
              {
                  "Header": "EXTERIOR",
                  "DescriptionValue": [
                      {
                          "Description": "EXTERIOR",
                          "Value": "Wheels: 20\" Ebony-Painted Machined Aluminum"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Tires: P255/55R20 AS BSW"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Steel Spare Wheel"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Compact Spare Tire Mounted Inside Under Cargo"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Clearcoat Paint"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Body-Colored Rear Bumper w/Black Rub Strip/Fascia Accent"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Body-Colored Front Bumper w/Black Bumper Insert"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Black Side Windows Trim, Black Front Windshield Trim and Black Rear Window Trim"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Black Bodyside Insert, Black Bodyside Cladding and Black Wheel Well Trim"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Body-Colored Door Handles"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Black Power Heated Side Mirrors w/Manual Folding"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Fixed Rear Window w/Fixed Interval Wiper, Heated Wiper Park and Defroster"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Deep Tinted Glass"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Speed Sensitive Rain Detecting Variable Intermittent Wipers"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Galvanized Steel/Aluminum Panels"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Lip Spoiler"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Black Grille"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Power Liftgate Rear Cargo Access"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Tailgate/Rear Door Lock Included w/Power Door Locks"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Roof Rack Rails Only"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Autolamp Auto On/Off Reflector Led Low/High Beam Auto High-Beam Daytime Running Lights Preference Setting Headlamps w/Delay-Off"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Perimeter/Approach Lights"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "LED Brakelights"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Headlights-Automatic Highbeams"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Front Fog Lamps"
                      },
                      {
                          "Description": "EXTERIOR",
                          "Value": "Laminated Glass"
                      }
                  ]
              },
              {
                  "Header": "ENTERTAINMENT",
                  "DescriptionValue": [
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Radio: B&O Sound System by Bang & Olufsen -inc: MP3 capability, 10 speakers, subwoofer, speed-compensated volume, SiriusXM w/360L and 3-month prepaid subscription (service is not available in Alaska and Hawaii), Ford digital experience w/13.2\" color LCD touchscreen in IP center-stack, Alexa built-in, Google Assistant, Google Maps and Google Play, pinch-to-zoom capability, 911 Assist, Apple CarPlay and Android Auto wireless compatibility, Note: SiriusXM services require a subscription, sold separately by SiriusXM after the trial period, Your SiriusXM service will automatically stop at the end of your trial unless you decide to subscribe, If you decide to continue service, the subscription plan chosen will automatically renew and be charged according to your chosen payment method at the then-current rates, Fees and taxes apply, See the SiriusXM customer agreement and privacy policy at http://www.siriusxm.com/ www.siriusxm.com for full terms and how to cancel, which includes online methods or calling 1-866-635-2349, Available in the 48 contiguous United States, D.C, and Puerto Rico (w/coverage limits and capable receiver), Visit http://www.siriusxm.com/FAQS for most current service area information, Availability of some services and features is subject to device capabilities and location restrictions, All fees, content and features are subject to change, SiriusXM, Pandora and all related logos are trademarks of Sirius XM Radio Inc, and its respective subsidiaries Eligible 2025 model-year vehicle receive complimentary access to 3-years of Alexa built-in and 1-year of Ford premium connectivity connected service plan enabling Google Assistant, Google Maps and Google Play which begins on the new warranty start date. Evolving technology/cellular networks/vehicle capability may limit functionality and prevent operation of connected features."
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Radio w/Seek-Scan, Clock, Steering Wheel Controls and Internal Memory"
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Streaming Audio"
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Integrated Roof Antenna"
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Bluetooth Wireless Phone Connectivity"
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "2 LCD Monitors In The Front"
                      },
                      {
                          "Description": "ENTERTAINMENT",
                          "Value": "Siriusxm Traffic Real-Time Traffic Display"
                      }
                  ]
              },
              {
                  "Header": "INTERIOR",
                  "DescriptionValue": [
                      {
                          "Description": "INTERIOR",
                          "Value": "Bucket Front Seats w/Leatherette Back Material"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "8-Way Driver Seat"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "6-Way Passenger Seat"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Manual Tilt/Telescoping Steering Column"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Gauges -inc: Speedometer, Odometer, Engine Coolant Temp, Tachometer, Oil Level, Trip Odometer and Trip Computer"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Power Rear Windows and Fixed 3rd Row Windows"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "FordPass Connect 5G Mobile Hotspot Internet Access"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Fixed 50-50 Bench ActiveX Cloth/Leatherette 3rd Row Seat Front, Manual Fold Into Floor, 2 Manual and Adjustable Head Restraints"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Heated Leather Steering Wheel"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Front Cupholder"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Rear Cupholder"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Compass"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Remote Keyless Entry w/Integrated Key Transmitter, Illuminated Entry, Illuminated Ignition Switch and Panic Button"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Remote Releases -Inc: Power Cargo Access"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Proximity Key For Doors And Push Button Start"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Garage Door Transmitter"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Cruise Control w/Steering Wheel Controls"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Adaptive w/Traffic Stop-Go"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Voice Activated Dual Zone Front Automatic Air Conditioning"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Rear HVAC w/Separate Controls"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "HVAC -inc: Underseat Ducts and Headliner/Pillar Ducts"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Locking Glove Box"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Driver Foot Rest"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Full Cloth Headliner"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Interior Trim -inc: Cloth/Metal-Look Instrument Panel Insert, Metal-Look Door Panel Insert, Piano Black Console Insert and Chrome/Metal-Look Interior Accents"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Leatherette Door Trim Insert"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Heated ActiveX Seat Material Captain's Chairs -inc: cloth inserts, red stitching, 8-way power driver w/memory (power function for tilt, lumbar and recline) and 6-way power front passenger (power function for lumbar and recline)"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Day-Night Rearview Mirror"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Driver And Passenger Visor Vanity Mirrors w/Driver And Passenger Illumination, Driver And Passenger Auxiliary Mirror"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Full Floor Console w/Covered Storage, Mini Overhead Console w/Storage and 4 12V DC Power Outlets"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Front And Rear Map Lights"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Fade-To-Off Interior Lighting"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Full Carpet Floor Covering -inc: Carpet Front And Rear Floor Mats"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Carpet Floor Trim"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Trunk/Hatch Auto-Latch"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Cargo Area Concealed Storage"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Cargo Space Lights"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Smart Device Remote Engine Start"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "FOB Controls -inc: Cargo Access and Remote Start"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Integrated Navigation System w/Voice Activation"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Driver / Passenger And Rear Door Bins"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Power 1st Row Windows w/Driver And Passenger 1-Touch Up/Down"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Delayed Accessory Power"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Power Door Locks w/Autolock Feature"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Driver Information Center"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Trip Computer"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Outside Temp Gauge"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Digital/Analog Appearance"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Redundant Digital Speedometer"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Front Center Armrest"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "2 Seatback Storage Pockets"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Manual w/Tilt Front Head Restraints and Manual Adjustable Rear Head Restraints"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Securilock Anti-Theft Ignition (pats) Immobilizer"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Perimeter Alarm"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "4 12V DC Power Outlets"
                      },
                      {
                          "Description": "INTERIOR",
                          "Value": "Air Filtration"
                      }
                  ]
              },
              {
                  "Header": "SAFETY",
                  "DescriptionValue": [
                      {
                          "Description": "SAFETY",
                          "Value": "BlueCruise (90-day free trial)"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "AdvanceTrac w/Roll Stability Control Electronic Stability Control (ESC) And Roll Stability Control (RSC)"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "ABS And Driveline Traction Control"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Side Impact Beams"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Dual Stage Driver And Passenger Seat-Mounted Side Airbags"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "BLIS (Blind Spot Information System) Blind Spot"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Pre-Collision Assist with Pedestrian Detection Front Cross Traffic Mitigation"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Lane Keeping Alert Lane Keeping Assist"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Lane Keeping Alert Lane Departure Warning"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Collision Mitigation-Front"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Driver Monitoring-Alert"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Evasion Assist"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Collision Mitigation-Rear"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Forward and Reverse Sensing System Front And Rear Parking Sensors"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Aerial View Camera System"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Tire Specific Low Tire Pressure Warning"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Dual Stage Driver And Passenger Front Airbags"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Safety Canopy System Curtain 1st, 2nd And 3rd Row Airbags"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Airbag Occupancy Sensor"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Driver And Passenger Knee Airbag"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Mykey System -inc: Top Speed Limiter, Audio Volume Limiter, Early Low Fuel Warning, Programmable Sound Chimes and Beltminder w/Audio Mute"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Rear Child Safety Locks"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Outboard Front Lap And Shoulder Safety Belts -inc: Height Adjusters and Pretensioners"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Back-Up Camera w/Washer"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Front Camera w/Washer"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Left Side Camera"
                      },
                      {
                          "Description": "SAFETY",
                          "Value": "Right Side Camera"
                      }
                  ]
              }
          ],
          "TechinicalSpecifications": [
              {
                  "Header": "Summary",
                  "DescriptionValue": [
                      {
                          "Description": "Vehicle Name",
                          "Value": "Ford Explorer"
                      },
                      {
                          "Description": "Body Style",
                          "Value": "Sport Utility"
                      }
                  ]
              },
              {
                  "Header": "Transmission",
                  "DescriptionValue": [
                      {
                          "Description": "Drivetrain",
                          "Value": "Four Wheel Drive"
                      },
                      {
                          "Description": "Trans Order Code",
                          "Value": "44T"
                      },
                      {
                          "Description": "Trans Type",
                          "Value": "10"
                      },
                      {
                          "Description": "Trans Description Cont.",
                          "Value": "Automatic w/OD"
                      },
                      {
                          "Description": "Trans Description Cont. Again",
                          "Value": ""
                      },
                      {
                          "Description": "First Gear Ratio (:1)",
                          "Value": "4.71"
                      },
                      {
                          "Description": "Second Gear Ratio (:1)",
                          "Value": "3.00"
                      },
                      {
                          "Description": "Third Gear Ratio (:1)",
                          "Value": "2.15"
                      },
                      {
                          "Description": "Fourth Gear Ratio (:1)",
                          "Value": "1.77"
                      },
                      {
                          "Description": "Fifth Gear Ratio (:1)",
                          "Value": "1.52"
                      },
                      {
                          "Description": "Sixth Gear Ratio (:1)",
                          "Value": "1.27"
                      },
                      {
                          "Description": "Reverse Ratio (:1)",
                          "Value": "4.88"
                      },
                      {
                          "Description": "Final Drive Axle Ratio (:1)",
                          "Value": "3.58"
                      },
                      {
                          "Description": "Seventh Gear Ratio (:1)",
                          "Value": "1.00"
                      },
                      {
                          "Description": "Eighth Gear Ratio (:1)",
                          "Value": "0.85"
                      }
                  ]
              },
              {
                  "Header": "Vehicle",
                  "DescriptionValue": [
                      {
                          "Description": "EPA Classification",
                          "Value": "Standard SUV 4WD"
                      }
                  ]
              },
              {
                  "Header": "Interior Dimensions",
                  "DescriptionValue": [
                      {
                          "Description": "Passenger Capacity",
                          "Value": "7"
                      },
                      {
                          "Description": "Passenger Volume (ft³)",
                          "Value": "152.9"
                      },
                      {
                          "Description": "Front Head Room (in)",
                          "Value": "38.9"
                      },
                      {
                          "Description": "Front Leg Room (in)",
                          "Value": "43"
                      },
                      {
                          "Description": "Front Shoulder Room (in)",
                          "Value": "62.1"
                      },
                      {
                          "Description": "Front Hip Room (in)",
                          "Value": "59.2"
                      },
                      {
                          "Description": "Second Head Room (in)",
                          "Value": "38.2"
                      },
                      {
                          "Description": "Second Leg Room (in)",
                          "Value": "39"
                      },
                      {
                          "Description": "Second Shoulder Room (in)",
                          "Value": "61.9"
                      },
                      {
                          "Description": "Second Hip Room (in)",
                          "Value": "59.1"
                      },
                      {
                          "Description": "Third Head Room (in)",
                          "Value": "38.9"
                      },
                      {
                          "Description": "Third Leg Room (in)",
                          "Value": "32.2"
                      },
                      {
                          "Description": "Third Shoulder Room (in)",
                          "Value": "54.6"
                      },
                      {
                          "Description": "Third Hip Room (in)",
                          "Value": "40.9"
                      }
                  ]
              },
              {
                  "Header": "Weight Information",
                  "DescriptionValue": [
                      {
                          "Description": "Base Curb Weight (lbs)",
                          "Value": "4457"
                      }
                  ]
              },
              {
                  "Header": "Mileage",
                  "DescriptionValue": [
                      {
                          "Description": "Fuel Economy Est-Combined (MPG)",
                          "Value": "- TBD -"
                      },
                      {
                          "Description": "EPA Fuel Economy Est - City (MPG)",
                          "Value": "- TBD -"
                      },
                      {
                          "Description": "EPA Fuel Economy Est - Hwy (MPG)",
                          "Value": "- TBD -"
                      }
                  ]
              },
              {
                  "Header": "Trailering",
                  "DescriptionValue": [
                      {
                          "Description": "Dead Weight Hitch - Max Trailer Wt. (lbs)",
                          "Value": "5000"
                      },
                      {
                          "Description": "Dead Weight Hitch - Max Tongue Wt. (lbs)",
                          "Value": "500"
                      },
                      {
                          "Description": "Wt Distributing Hitch - Max Trailer Wt. (lbs)",
                          "Value": "5300"
                      },
                      {
                          "Description": "Wt Distributing Hitch - Max Tongue Wt. (lbs)",
                          "Value": "530"
                      },
                      {
                          "Description": "Maximum Trailering Capacity (lbs)",
                          "Value": "5300"
                      }
                  ]
              },
              {
                  "Header": "Engine",
                  "DescriptionValue": [
                      {
                          "Description": "Engine Order Code",
                          "Value": "99H"
                      },
                      {
                          "Description": "Engine Type",
                          "Value": "Intercooled Turbo Premium Unleaded I-4"
                      },
                      {
                          "Description": "Displacement",
                          "Value": "2.3 L/140"
                      },
                      {
                          "Description": "Fuel System",
                          "Value": "Gasoline Direct Injection"
                      },
                      {
                          "Description": "SAE Net Horsepower @ RPM",
                          "Value": "300 @ 5500"
                      },
                      {
                          "Description": "SAE Net Torque @ RPM",
                          "Value": "310 @ 3500"
                      }
                  ]
              },
              {
                  "Header": "Emissions",
                  "DescriptionValue": [
                      {
                          "Description": "Tons/yr of CO2 Emissions @ 15K mi/year",
                          "Value": "- TBD -"
                      }
                  ]
              },
              {
                  "Header": "Suspension",
                  "DescriptionValue": [
                      {
                          "Description": "Suspension Type - Front",
                          "Value": "Strut"
                      },
                      {
                          "Description": "Suspension Type - Rear",
                          "Value": "Multi-Link"
                      },
                      {
                          "Description": "Suspension Type - Front (Cont.)",
                          "Value": "Strut"
                      },
                      {
                          "Description": "Suspension Type - Rear (Cont.)",
                          "Value": "Multi-Link"
                      }
                  ]
              },
              {
                  "Header": "Tires",
                  "DescriptionValue": [
                      {
                          "Description": "Front Tire Order Code",
                          "Value": ""
                      },
                      {
                          "Description": "Rear Tire Order Code",
                          "Value": ""
                      },
                      {
                          "Description": "Spare Tire Order Code",
                          "Value": ""
                      },
                      {
                          "Description": "Front Tire Size",
                          "Value": "P255/55VR20"
                      },
                      {
                          "Description": "Rear Tire Size",
                          "Value": "P255/55VR20"
                      },
                      {
                          "Description": "Spare Tire Size",
                          "Value": "Compact"
                      }
                  ]
              },
              {
                  "Header": "Wheels",
                  "DescriptionValue": [
                      {
                          "Description": "Front Wheel Size (in)",
                          "Value": "20 X 8"
                      },
                      {
                          "Description": "Rear Wheel Size (in)",
                          "Value": "20 X 8"
                      },
                      {
                          "Description": "Spare Wheel Size (in)",
                          "Value": "Compact"
                      },
                      {
                          "Description": "Front Wheel Material",
                          "Value": "Aluminum"
                      },
                      {
                          "Description": "Rear Wheel Material",
                          "Value": "Aluminum"
                      },
                      {
                          "Description": "Spare Wheel Material",
                          "Value": "Steel"
                      }
                  ]
              },
              {
                  "Header": "Steering",
                  "DescriptionValue": [
                      {
                          "Description": "Steering Type",
                          "Value": "Rack-Pinion"
                      }
                  ]
              },
              {
                  "Header": "Brakes",
                  "DescriptionValue": [
                      {
                          "Description": "Brake Type",
                          "Value": "4-Wheel Disc"
                      },
                      {
                          "Description": "Brake ABS System",
                          "Value": "4-Wheel"
                      },
                      {
                          "Description": "Disc - Front (Yes or   )",
                          "Value": "Yes"
                      },
                      {
                          "Description": "Disc - Rear (Yes or   )",
                          "Value": "Yes"
                      },
                      {
                          "Description": "Front Brake Rotor Diam x Thickness (in)",
                          "Value": "13.6"
                      },
                      {
                          "Description": "Rear Brake Rotor Diam x Thickness (in)",
                          "Value": "12.6"
                      },
                      {
                          "Description": "Drum - Rear (Yes or   )",
                          "Value": ""
                      },
                      {
                          "Description": "Rear Drum Diam x Width (in)",
                          "Value": ""
                      }
                  ]
              },
              {
                  "Header": "Fuel Tank",
                  "DescriptionValue": [
                      {
                          "Description": "Fuel Tank Capacity, Approx (gal)",
                          "Value": "18.6"
                      }
                  ]
              },
              {
                  "Header": "Exterior Dimensions",
                  "DescriptionValue": [
                      {
                          "Description": "Wheelbase (in)",
                          "Value": "119.1"
                      },
                      {
                          "Description": "Length, Overall (in)",
                          "Value": "198.8"
                      },
                      {
                          "Description": "Width, Max w/o mirrors (in)",
                          "Value": "78.9"
                      },
                      {
                          "Description": "Height, Overall (in)",
                          "Value": "70.2"
                      },
                      {
                          "Description": "Track Width, Front (in)",
                          "Value": "66.9"
                      },
                      {
                          "Description": "Track Width, Rear (in)",
                          "Value": "66.9"
                      },
                      {
                          "Description": "Min Ground Clearance (in)",
                          "Value": "8.2"
                      },
                      {
                          "Description": "Liftover Height (in)",
                          "Value": "32.8"
                      }
                  ]
              },
              {
                  "Header": "Cargo Area Dimensions",
                  "DescriptionValue": [
                      {
                          "Description": "Cargo Area Length @ Floor to Seat 1 (in)",
                          "Value": "84.1"
                      },
                      {
                          "Description": "Cargo Area Length @ Floor to Seat 2 (in)",
                          "Value": "49.8"
                      },
                      {
                          "Description": "Cargo Area Length @ Floor to Seat 3 (in)",
                          "Value": "20.8"
                      },
                      {
                          "Description": "Cargo Area Width @ Beltline (in)",
                          "Value": "64.5"
                      },
                      {
                          "Description": "Cargo Box Width @ Wheelhousings (in)",
                          "Value": "47.6"
                      },
                      {
                          "Description": "Cargo Box (Area) Height (in)",
                          "Value": "32.8"
                      },
                      {
                          "Description": "Cargo Volume to Seat 2 (ft³)",
                          "Value": "46"
                      },
                      {
                          "Description": "Cargo Volume to Seat 3 (ft³)",
                          "Value": "16.3"
                      }
                  ]
              }
          ],
          "InventoryVehicleDetail": {
              "StockNumber": "SGA18504",
              "MSRPWithAccessories": 53740,
              "InventoryStatus": "S",
              "PriceWithSavings": 0,
              "Reservable": true,
              "DealerFee": 0,
              "StockType": "NEW",
              "DiscountedAmount": 0,
              "ELeadMinusCustCash": 50865.22,
              "ANSaving": 0,
              "ELeadTotalPrice": 0,
              "SmartChoicePrice": 0,
              "TotalPrice": 0,
              "Certification": "MW",
              "StockTypeForSite": "NEW",
              "IsMobilityVehicle": false,
              "MobilityPricing": null,
              "ExternalColorRGBHex": "505A5B",
              "Features": "Panoramic Roof,Navigation System,3rd Row Seat,Lane Keeping Assist,Front &amp; 2Nd Rows Floor Liners W/Carpet Floor Mats -Inc: Front And 2Nd Rows Black Carpet Floor Mats,2Nd Row Captain'S Chairs W/E-Z Entry &amp; Armrest -Inc: E-Z Entry Is Manually Activated, Replaces Standard 2Nd Row Captain'S Chairs,Keyless Start,Panoramic Vista Roof W/Power Shade -Inc: Remote Control Front Windows (Opens Front Windows From Outside Of The Vehicle Via The Key Fob),Rear Spoiler,Premium Package -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline), 110V/150W Ac Power Outlet, Replaces The Powerpoint Port On The Rear Side Of The Center Floor Console, Heated Activex Seat Material Cap Chairs, Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline), Auto-Dimming Interior Rearview Mirror, Power Tilt/Telescoping Steering Column, Power-Folding Sideview Mirrors W/Autofold, Power And Heated Glass, Led Turn Signal Indicators, Security Approach Lamps, Driver'S Side Auto-Dimming And Driver And Passenger Side Memory, Rain-Sensing Wipers (Front Only), Ambient Lighting, Wireless Charging Pad, 2Nd Row Heated Seats,St-Line Street Pack -Inc: Wheels: 21\" Magnetite-Painted Aluminum, Tires: P275/45R21 As Bsw, Performance Brakes, Red Painted Perf Front &amp; Rear Brake Calipers,Onyx, Heated Activex Seat Material Captain'S Chairs -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline),Onyx, Heated Activex Seat Material Cap Chairs -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline),Carbonized Gray Metallic,Equipment Group 300A Standard Package,Transmission: 10-Speed Automatic (Std),Engine: 2.3L Ecoboost I-4 -Inc: Auto Start-Stop Technology (Std)",
              "ROGeneratedText": "",
              "NotePrefix": "",
              "StoreNotes": "",
              "MerchandisingText": "Panoramic Roof,Navigation System,3rd Row Seat,Lane Keeping Assist,Front &amp; 2Nd Rows Floor Liners W/Carpet Floor Mats -Inc: Front And 2Nd Rows Black Carpet Floor Mats,2Nd Row Captain'S Chairs W/E-Z Entry &amp; Armrest -Inc: E-Z Entry Is Manually Activated, Replaces Standard 2Nd Row Captain'S Chairs,Keyless Start,Panoramic Vista Roof W/Power Shade -Inc: Remote Control Front Windows (Opens Front Windows From Outside Of The Vehicle Via The Key Fob),Rear Spoiler,Premium Package -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline), 110V/150W Ac Power Outlet, Replaces The Powerpoint Port On The Rear Side Of The Center Floor Console, Heated Activex Seat Material Cap Chairs, Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline), Auto-Dimming Interior Rearview Mirror, Power Tilt/Telescoping Steering Column, Power-Folding Sideview Mirrors W/Autofold, Power And Heated Glass, Led Turn Signal Indicators, Security Approach Lamps, Driver'S Side Auto-Dimming And Driver And Passenger Side Memory, Rain-Sensing Wipers (Front Only), Ambient Lighting, Wireless Charging Pad, 2Nd Row Heated Seats,St-Line Street Pack -Inc: Wheels: 21\" Magnetite-Painted Aluminum, Tires: P275/45R21 As Bsw, Performance Brakes, Red Painted Perf Front &amp; Rear Brake Calipers,Onyx, Heated Activex Seat Material Captain'S Chairs -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline),Onyx, Heated Activex Seat Material Cap Chairs -Inc: Cloth Inserts, Red Stitching, 8-Way Power Driver W/Memory (Power Function For Tilt, Lumbar And Recline) And 6-Way Power Front Passenger (Power Function For Lumbar And Recline),Carbonized Gray Metallic,Equipment Group 300A Standard Package,Transmission: 10-Speed Automatic (Std),Engine: 2.3L Ecoboost I-4 -Inc: Auto Start-Stop Technology (Std)<br><br>",
              "NoteSuffix": "",
              "HyperionId": "2025",
              "Payments": null,
              "MonthlyPayments": {
                  "FinancePayments": {
                      "Apr": 0,
                      "Term": 0,
                      "MonthlyPaymentAmount": 0,
                      "AnnualMiles": 0
                  },
                  "LeasePayments": {
                      "Apr": 0,
                      "Term": 0,
                      "MonthlyPaymentAmount": 0,
                      "AnnualMiles": 0
                  }
              },
              "PriceTiers": [
                  {
                      "TierId": 87,
                      "TierDescription": null,
                      "Price": 51865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 88,
                      "TierDescription": null,
                      "Price": 51865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 91,
                      "TierDescription": null,
                      "Price": 0,
                      "DealerFee": 0,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 92,
                      "TierDescription": null,
                      "Price": 51865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 93,
                      "TierDescription": null,
                      "Price": 51865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 94,
                      "TierDescription": null,
                      "Price": 50865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 95,
                      "TierDescription": null,
                      "Price": 51865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 96,
                      "TierDescription": null,
                      "Price": 50865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 97,
                      "TierDescription": null,
                      "Price": 50865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  },
                  {
                      "TierId": 99,
                      "TierDescription": null,
                      "Price": 50865.22,
                      "DealerFee": 250,
                      "AddDealerFee": false,
                      "TotalPrice": 0,
                      "DAOTotal": 0
                  }
              ],
              "ActualPhotos": [
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/68116dd64a6c4bf0983621460c63f495_[w]x[h]_Q75_V4.jpg",
                      "Index": "1"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/3d1f6ee6325140a39ffbe690ba3ab561_[w]x[h]_Q75_V4.jpg",
                      "Index": "2"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/02e7bd07cba14342978cbb456643e54e_[w]x[h]_Q75_V4.jpg",
                      "Index": "3"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/d226b4c9ff8f4d73b5c8e270422d0d20_[w]x[h]_Q75_V4.jpg",
                      "Index": "4"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/cab6e08548f74deeb0934724c9df573b_[w]x[h]_Q75_V4.jpg",
                      "Index": "5"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/32a6ea5d2ad7424ab0161efa2561ac19_[w]x[h]_Q75_V4.jpg",
                      "Index": "6"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/bb8ea6d999924d23b779c66ffe8e62e1_[w]x[h]_Q75_V4.jpg",
                      "Index": "7"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/fd3338207f4a4b1a865a09f1f2494d12_[w]x[h]_Q75_V4.jpg",
                      "Index": "8"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/ec4bea98fa504c12a180394a0964a0ba_[w]x[h]_Q75_V4.jpg",
                      "Index": "9"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/472bac80594f44fb8b0b2863ad3ef8a7_[w]x[h]_Q75_V4.jpg",
                      "Index": "10"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/38b5e043771941dbb41bd1180d875663_[w]x[h]_Q75_V4.jpg",
                      "Index": "11"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/59ee7ba4f7804f4d8dae8d7936e9518f_[w]x[h]_Q75_V4.jpg",
                      "Index": "12"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/da1e81c1da8841dc8224c6da3cba9aa4_[w]x[h]_Q75_V4.jpg",
                      "Index": "13"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/ed9a9a86996749d1aa658f80941b189d_[w]x[h]_Q75_V4.jpg",
                      "Index": "14"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/582e28889ca84270af8965fdaa35ce09_[w]x[h]_Q75_V4.jpg",
                      "Index": "15"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/19a70094062a416e8bf326d6d1efe189_[w]x[h]_Q75_V4.jpg",
                      "Index": "16"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/c893bcf35f99423db3ab7b40f3f44052_[w]x[h]_Q75_V4.jpg",
                      "Index": "17"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/d0087ba8f9854a60a1e4c1840453e697_[w]x[h]_Q75_V4.jpg",
                      "Index": "18"
                  },
                  {
                      "PhotoUrl": "//az336639.vo.msecnd.net/actualcdn/443dd0f0c42d492586426b8579e1778d_[w]x[h]_Q75_V4.jpg",
                      "Index": "101"
                  }
              ],
              "StockPhotos": [],
              "PricingStack": {
                  "Items": [
                      {
                          "Name": "AutonationPrice",
                          "Value": 51865.22,
                          "LowestName": "AutonationPrice",
                          "LowestValue": 51865.22,
                          "SortOrder": 4,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "VehicleSellingPrice",
                          "Value": 51865.22,
                          "LowestName": "VehicleSellingPrice",
                          "LowestValue": 51865.22,
                          "SortOrder": 7,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Difference",
                          "Value": 51865.22,
                          "LowestName": "Difference",
                          "LowestValue": 51865.22,
                          "SortOrder": 9,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "BalanceDue",
                          "Value": 54888.66,
                          "LowestName": "BalanceDue",
                          "LowestValue": 54888.66,
                          "SortOrder": 14,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Msrp",
                          "Value": 53740,
                          "LowestName": "Msrp",
                          "LowestValue": 53740,
                          "SortOrder": 0,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Dealer Fee",
                          "Value": 0,
                          "LowestName": "Dealer Fee",
                          "LowestValue": 0,
                          "SortOrder": 1,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "AutonationSavings",
                          "Value": 1874.78,
                          "LowestName": "AutonationSavings",
                          "LowestValue": 1874.78,
                          "SortOrder": 3,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Trade-In Value",
                          "Value": 0,
                          "LowestName": "Trade-In Value",
                          "LowestValue": 0,
                          "SortOrder": 8,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Payoff balance",
                          "Value": 0,
                          "LowestName": "Payoff balance",
                          "LowestValue": 0,
                          "SortOrder": 10,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Tax",
                          "Value": 2612.94,
                          "LowestName": "Tax",
                          "LowestValue": 2612.94,
                          "SortOrder": 11,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Registration Fee",
                          "Value": 143.5,
                          "LowestName": "Registration Fee",
                          "LowestValue": 143.5,
                          "SortOrder": 12,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Title Fee",
                          "Value": 5,
                          "LowestName": "Title Fee",
                          "LowestValue": 5,
                          "SortOrder": 12,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Vendor Fee",
                          "Value": 12,
                          "LowestName": "Vendor Fee",
                          "LowestValue": 12,
                          "SortOrder": 12,
                          "ItemDisplayMode": "lock"
                      },
                      {
                          "Name": "Dealer Fee",
                          "Value": 250,
                          "LowestName": "Dealer Fee",
                          "LowestValue": 250,
                          "SortOrder": 13,
                          "ItemDisplayMode": "lock"
                      }
                  ]
              },
              "IncentivePriceBreakdown": [
                  {
                      "Description": "- Exclusive cash reward exclusively for members of the following US Military Branches: Eligible Customers: * Active Military Personnel in the Army, Navy, Air Force, Marines, Coast Guard, National Guard * Reservists serving on Active Duty and members of the Delayed Entry/Enlistment Program (DEP) * Veterans within 2 Years of separation * Retirees * Spouse/Surviving Spouse and other household members. Customers will now be directed to www.fordrecognizesu.com/military to register and be validated online for their military eligibility according to the program rules PRIOR to purchasing their vehicle. Once verified, customers will receive a certificate number that will be used to claim the program in Smart VINCENT. - Offer is valid for the purchase or lease of a new eligible Ford Division vehicle. Limit one Bonus Cash offer per vehicle purchased or leased. -Dealers are no longer required to keep Military Personal documentation proof in the dealer jacket. Documentation will be stored through Troop ID and approved by the certificate number issued. - Qualifying buyers will receive Bonus Cash good toward the purchase or lease of any eligible new vehicle. - Final paid vehicles are NOT eligible.",
                      "Value": 500,
                      "SpecialSmallTitle": "150038"
                  },
                  {
                      "Description": "Exclusive cash reward exclusively for First Responders serving communities with the following jobs: Eligible Customers: Police - Police Officer - Sheriff/Sheriffs Deputy - Correctional Officer - State Trooper - Federal Law Enforcement officer (Example: Customs, Homeland and Security, etc.) Fire Department - Career Firefighter - Volunteer Firefighter EMT - EMT - Paramedic - 911 Dispatcher Occupations that do not qualify for the incentive at this time: - Registered Nurse - Ski Patrol-unless the customer has a EMT license - CERT Team Members (Community Emergency Response team) - VIPS- Volunteers in Police Service - Search and Rescue - Emergency Management Volunteers - Customers will now be directed to www.fordspecialoffer.com/firstresponders to register and be validated online for their First Responders eligibility according to the program rules PRIOR to purchasing their vehicle. Once verified, customers will receive a certificate number that will be used to claim the program in VINCENT. - Offer is valid for the purchase or lease of a new eligible Lincoln Division vehicle. Limit one Bonus Cash offer per vehicle purchased or leased. - Dealers are not required to keep First Responder documentation proof in the dealer jacket. Documentation will be stored through First Responder ID and approved by the certificate number issued. - Qualifying buyers will receive Bonus Cash good toward the purchase or lease of any eligible new vehicle. - Retirees are NOT eligible - Final paid vehicles are NOT eligible.",
                      "Value": 500,
                      "SpecialSmallTitle": "150039"
                  },
                  {
                      "Description": "",
                      "Value": 0,
                      "SpecialSmallTitle": "152018"
                  }
              ],
              "VehicleIncentives": [],
              "AccessoriesPriceBreakdown": {
                  "TotalPrice": 0,
                  "PriceBreakdown": null
              },
              "VehicleHistory": {
                  "Owners": "0",
                  "ServiceRecords": "0",
                  "Accidents": "0",
                  "CarfaxUrl": null
              }
          }
      },
      "userContext": {
          "HasAttribution": false,
          "LeadSource": {
              "ProviderId": null,
              "SubProviderId": null,
              "LeadType": null
          },
          "UserId": null,
          "CustomerId": null,
          "FirstName": null,
          "MiddleInitial": null,
          "LastName": null,
          "IsHomeDelivery": false,
          "Address1": null,
          "Address2": null,
          "City": null,
          "State": null,
          "Zipcode": "58772",
          "DOB": null,
          "HomePhone": null,
          "MobilePhone": null,
          "EmailAddress": null,
          "Password": null,
          "RefreshToken": null,
          "PreferredContactMethod": 0,
          "PreferredStoreId": null,
          "PreferredCollisionCenterId": null,
          "PreferredCity": null,
          "PreferredState": null,
          "PreferredZipCode": "58772",
          "IpZipCode": null,
          "IpCoordinates": {
              "Longitude": 0,
              "Latitude": 0
          },
          "PreferredZipCodeChanged": false,
          "PreferredZipCodeCoordinates": {
              "Longitude": -102.5498,
              "Latitude": 48.9953
          },
          "IsNewRegistration": false,
          "IsSilentAuthenticated": false,
          "IsFacebookUser": false,
          "FacebookAccessToken": null,
          "AccessToken": null,
          "CreatedDate": "0001-01-01T00:00:00",
          "LastLoginDate": "0001-01-01T00:00:00",
          "IsBusinessUser": false,
          "IsEMTUser": false,
          "EditComparisonSavedItemId": 0,
          "GetLatestUserVehicleCount": false,
          "ModifiedDate": "0001-01-01T00:00:00",
          "PinModifiedDateTime": "0001-01-01T00:00:00",
          "UserActionType": 0,
          "ContactSourceId": 0,
          "VerifyPin": 0,
          "IsConfirmationLinkExpried": false,
          "IsEmailVerified": false,
          "IsSceUserIdLinkedWithUserId": false,
          "StoreContactHyperionIds": null,
          "LocaleId": null,
          "SceId": null,
          "PaymentId": null,
          "UserCurrentState": 0,
          "MarketDNS": null,
          "UCSetFromRedis": true,
          "SceData": {
              "displayReservationFailureMessage": false,
              "reservationID": null,
              "SCEId": null,
              "OpptId": 0,
              "SceUserId": null,
              "OpptContactId": 0,
              "DisplayLastAnxActivityMessage": false,
              "LastAnxActivity": 0,
              "EmailAddress": null,
              "FirstName": null,
              "LastName": null,
              "Phone": null,
              "PostalCode": null,
              "SCEVehicleHyperionId": null,
              "SCEVin": null,
              "OpptVehicleId": 0,
              "SCETradeInVehicleId": null,
              "SCETradeInVin": null,
              "SceRecords": [],
              "CurrentVehicleOfInterest": null,
              "PotentialSceData": {
                  "VehicleOfInterest": {
                      "HyperionId": null,
                      "Vin": null
                  }
              },
              "SCETestDriveId": null,
              "SCEReservedVin": null,
              "SCEReservedVinExpiration": "0001-01-01T00:00:00",
              "SCESource": null,
              "SavedSceVehicles": [],
              "SavedSceStoreAppointments": [],
              "SavedSceTradeInVehicles": [],
              "SavedCFS": {
                  "SceId": null,
                  "OpptId": 0,
                  "Survey": [],
                  "SavedPlanIds": [],
                  "SavedPlans": [],
                  "RecommendedPlans": []
              },
              "IsScpUnlocked": false,
              "ReservedVin": null,
              "ReservedVinExpiration": "0001-01-01T00:00:00"
          },
          "SceVehicleId": 0,
          "Appointments": null,
          "AttributionVariable": null,
          "AttributionValue": {},
          "SiteId": null,
          "ViewStore": null,
          "SiteViewType": 1,
          "UserVehicles": null,
          "ClearStorage": false,
          "DeepLinkUserInfo": {
              "Hyperion": null,
              "OpportunityId": 0
          },
          "CashDown": 0,
          "IntendedUse": 0,
          "PaymentOption": 0,
          "PersonalDetailsType": null,
          "TradeInInfo": null,
          "SurveyQuestions": null,
          "ShortFormIDsType": null,
          "VehicleTransactions": null,
          "BuyNow": {
              "BuyNowVehicles": [],
              "BuyNowVehicleContext": {},
              "HoldTransactionRequest": {},
              "ShowRecalculatePopup": false,
              "IsPaymentExist": false,
              "IsOnBrand": false,
              "TradeInRangePayOffAmount": null,
              "TradeInRangePayOffType": null,
              "TradeInRangeCustomerEstimate": null,
              "TradeInRangeVehicleId": null
          },
          "CreditApplication": null,
          "CreditPersistedData": {
              "CreditAppId": null,
              "OpptId": 0
          },
          "EMT": {
              "OpportunityId": 0,
              "CustomerDealId": 0,
              "Vin": null,
              "Year": null,
              "Make": null,
              "Model": null,
              "VehicleValue": null,
              "AppraisalDateTime": "0001-01-01T00:00:00",
              "OwnershipType": 0,
              "PayoffAmount": null,
              "NumberOfPaymentsLeft": null,
              "MonthlyPayment": null,
              "APR": null,
              "EquityAmount": null,
              "EquityType": 0
          },
          "IsDeepLink": false,
          "ShouldShowLeadForm": false,
          "IsAssociateOnlyViewType": false,
          "IsCustEmailViewType": false,
          "DeepLinkSellCarTradeInInfo": {
              "ImageUrl": null,
              "vin": null,
              "year": null,
              "make": null,
              "model": null,
              "trim": null,
              "chromeStyleId": null,
              "mileage": 0,
              "uniqueVehicleCode": null,
              "priceRange": null
          },
          "HasSubmittedRangeOffer": false,
          "RangeOfferInfo": null,
          "UserPreQualificationInfo": null,
          "HyperionFromCookie": null,
          "OpportunityIdFromCookie": 0
      },
      "fullURL": "http%3A%2F%2Flocalhost%3A4000%2Fpre-qualification%2F1FMUK8KH2SGA18504"
  }
}
